import React, { Component } from "react";
import { Accordion, Card, Button, Modal, Spinner } from "react-bootstrap";
import { Route, Link, Redirect } from "react-router-dom";
import buysellicon from "../assets/buysellicon.svg";
import dpsicon from "../assets/dpsicon.svg";
import righticon from "../assets/righticon.svg";
import transfericon from "../assets/transfericon.svg";
import increaseicon from "../assets/increaseicon.svg";
import inouticon from "../assets/inouticon.svg";
import stockprofiticon from "../assets/stockprofiticon.svg";
import excelicon from "../assets/excelicon.svg";
import profitcredit from "../assets/profitcredit.svg";
import DashboardContent from "./DashboardContent";
import Turnover from "./Turnover";
import Profit from "./Profit";
import Chart from "./Chart";
import BuySell from "./BuySell";
import InOut from "./InOut";
import DPS from "./DPS";
import CapitalIncrease from "./CapitalIncrease";
import AdvanceRight from "./AdvanceRight";
import Transfer from "./Transfer";
import BrokerBenefit from "./BrokerBenefit";
import BrokerCredit from "./BrokerCredit";
import ImportExcel from "./ImportExcel";
import BrokersContent from "./BrokersContent";
import BasketsContent from "./BasketsContent";
import Profile from "./Profile";
import SideButton from "../components/SideButton";
import MessagePrompt from "../components/MessagePrompt";
import Loading from "../components/Loading";
import FormMenuItem from "../components/FormMenuItem";
import turnover1 from "../assets/turnover1.png";
import turnover2 from "../assets/turnover2.png";
import profit1 from "../assets/profit1.png";
import profit2 from "../assets/profit2.png";
import avatarBlue from "../assets/avatar-blue.png";
import avatarWhite from "../assets/avatar-white.png";
import burcelLogoGraphic from "../assets/burcelLogoGraphic.png";
import exit from "../assets/exit.png";
import exit2 from "../assets/exit2.png";
import menu from "../assets/menu.png";
import chart from "../assets/chart.png";
import chart1 from "../assets/chart1.png";
import portfolio from "../assets/portfolio.png";
import portfolio1 from "../assets/portfolio1.png";
import BaksetItem from "../components/BasketItem";

// import { toast } from 'react-toastify';
import { Form, Image } from "react-bootstrap";
import Broker from "../components/Broker";
import edit from "../assets/edit.png";
import NumberFormat from "react-number-format";
import { ToastContainer, Flip, toast } from "react-toastify";

import ScrollContainer from "react-indiana-drag-scroll";

import { stack as Menu } from "react-burger-menu";

export default class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.target = ".dashboardMiddle";
    this.type = "Push";
    this.sidebarItems = [];
    this.state = {
      newVersionText: [],
      newVersion: false,
      dashboardHasTransaction: false,
      dpsActionError: "",
      silentRefresh: false,
      increaseActionError: "",
      dpsButtonDisabled: false,
      increaseButtonDisabled: false,
      currentPortfolioFilter: "today",
      currentPortfolioDate: "",
      deleteTransButtonDisabled: false,
      currentDeleteTransaction: null,
      deleteTransaction: false,
      dpsCost: 0,
      dpsSuggestionResult: [],
      dpsSuggestion: false,
      DPSState: false,
      CapitalIncreaseState: false,
      AdvanceRightState: false,
      BrokerBenefitState: false,
      BrokerCreditState: false,
      ImportExcelState: false,
      TransferState: false,
      transferDisable: false,
      seconds: 0,
      totalsecend: 60,
      top: "0px",
      left: "0px",
      width: 0,
      height: 0,
      menuOpen: false,
      token: "",
      serverResponse: false,
      sidebarCreated: false,
      showMenuButton: false,
      sideMenuSelectedIndex: 0,
      menuButtons: [
        { title: "پرتفوی", url: "/", icon1: portfolio1, icon2: portfolio },
        { title: "نمودار", url: "/Chart", icon1: chart1, icon2: chart },
        {
          title: "گردش حساب",
          url: "/Turnover",
          icon1: turnover1,
          icon2: turnover2,
        },
        { title: "سود", url: "/Profit", icon1: profit1, icon2: profit2 },
      ],
      modalBackDrop: "true",
      editProfile: false,
      ModalShow: false,
      symbolsData: [],
      brokersData: [],
      selectedPortfolioId: "0",
      selectedPortfolioName: "کل سبدها",
      selectedPortfolioPercent: 0,
      userBrokersData: [],
      userBasketsData: [],
      userBasketsDataMain: [],
      tabselectedindex: 0,
      brokerselectedindex: null,
      selectedBrokerId: 0,
      // selectedBrokerName:'',
      pageSettings: { pageSize: 10 },
      filterOptions: { mode: "Immediate" },
      reportData: [
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد2",
          Operation: "خرید",
          Broker: "کارگزاری2",
          Basket: "سبد2",
          AvragePrice: "12000",
          Volume: "13",
          Cost: "6000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
        {
          NamadName: "نماد1",
          Operation: "فروش",
          Broker: "کارگزاری1",
          Basket: "سبد1",
          AvragePrice: "1000",
          Volume: "15",
          Cost: "5000",
        },
      ],
      archiveBroker: false,
      archiveBasket: false,
      addBroker: false,
      addBasket: false,
      editBroker: false,
      editBasket: false,
      archiveBrokerId: null,
      archiveBasketId: null,
      archiveBrokerName: "",
      archiveBasketName: "",
      brokerName: "",
      shareBaskett: false,
      profilePicture: avatarWhite,
      selectedPortfolio: [],
      selectedBasketChart1: [],
      chart1BasedOn: [
        { title: "ارزش روز", target: "total_price" },
        { title: "بهای تمام شده", target: "cost" },
      ],
      chart2BasedOn: [
        { title: "ارزش روز", target: "total_price" },
        { title: "بهای تمام شده", target: "cost" },
      ],
      selectedBasketChart2: [],
      selectedBasketChart3: [],
      selectedBasketChart4: [],
      turnOverData: [],
      BuySellState: false,
      InOutState: true,
      currentPotfolioType: "last",
      FormMenuVisible: false,
      inoutPopup: false,
      buysellPopup: false,
      dpsPopup: false,
      capitalincreasePopup: false,
      advancerightPopup: false,
      brokerbenefitPopup: false,
      brokercreditPopup: false,
      importexcelPopup: false,
      transferPopup: false,
      userFullName: "",
      twrrMessage: false,
      mwrrMessage: false,
      gridLocaleText: {
        // Set Filter
        selectAll: "انتخاب همه",
        selectAllSearchResults: "انتخاب همه نتایج جستجو",
        searchOoo: "جستجو...",
        blanks: "خالی",
        noMatches: "پشدا نشد",

        // Number Filter & Text Filter
        filterOoo: "فیلتر...",
        equals: "مساوی",
        notEqual: "نا مساوی",

        // Number Filter
        lessThan: "کمتر از",
        greaterThan: "بیشتر از",
        lessThanOrEqual: "کوچکتر مساوی",
        greaterThanOrEqual: "بزرگتر مساوی",
        inRange: "در محدوده",
        inRangeStart: "به",
        inRangeEnd: "از",

        // Text Filter
        contains: "شامل",
        notContains: "شامل نباشد",
        startsWith: "شروع با",
        endsWith: "پایان با",

        // Date Filter
        dateFormatOoo: "Yyyy-mm-dd",

        // Filter Conditions
        andCondition: "و",
        orCondition: "یا",

        // Filter Buttons
        applyFilter: "تایید",
        resetFilter: "راه اندازی مجدد",
        clearFilter: "پاک کردن",
        cancelFilter: "انصراف",

        // Side Bar
        columns: "ستون ها",
        filters: "فیلترها",

        // columns tool panel
        pivotMode: "Pivot Mode",
        groups: "Row Groups",
        rowGroupColumnsEmptyMessage: "Drag here to set row groups",
        values: "Values",
        valueColumnsEmptyMessage: "Drag here to aggregate",
        pivots: "Column Labels",
        pivotColumnsEmptyMessage: "Drag here to set column labels",

        // Header of the Default Group Column
        group: "گروه",

        // Other
        loadingOoo: "لطفاً شکیبا باشید...",
        noRowsToShow: "هیچ موردی یافت نشد",
        enabled: "فعال",

        // Menu
        pinColumn: "Pin Column",
        pinLeft: "Pin Left",
        pinRight: "Pin Right",
        noPin: "No Pin",
        valueAggregation: "Value Aggregation",
        autosizeThiscolumn: "Autosize This Column",
        autosizeAllColumns: "Autosize All Columns",
        groupBy: "Group by",
        ungroupBy: "Un-Group by",
        resetColumns: "Reset Columns",
        expandAll: "Expand All",
        collapseAll: "Close All",
        copy: "Copy",
        ctrlC: "Ctrl+C",
        copyWithHeaders: "Copy With Headers",
        paste: "Paste",
        ctrlV: "Ctrl+V",
        export: "Export",
        csvExport: "CSV Export",
        excelExport: "Excel Export (.xlsx)",
        excelXmlExport: "Excel Export (.xml)",

        // Enterprise Menu Aggregation and Status Bar
        sum: "جمع",
        min: "کمترین",
        max: "بیشترین",
        none: "None",
        count: "تعداد",
        avg: "میانگین",
        filteredRows: "فیلتر شده",
        selectedRows: "انتخاب شده",
        totalRows: "جمع ردیف ها",
        totalAndFilteredRows: "ردیف ها",
        page: "صفحه",
        more: "بیشتر",
        to: "تا",
        of: "از",
        next: "بعدی",
        last: "آخرین",
        first: "اولین",
        previous: "قبلی",

        // Enterprise Menu (Charts)
        pivotChartAndPivotMode: "Pivot Chart & Pivot Mode",
        pivotChart: "Pivot Chart",
        chartRange: "Chart Range",

        columnChart: "Column",
        groupedColumn: "Grouped",
        stackedColumn: "Stacked",
        normalizedColumn: "100% Stacked",

        barChart: "Bar",
        groupedBar: "Grouped",
        stackedBar: "Stacked",
        normalizedBar: "100% Stacked",

        pieChart: "Pie",
        pie: "Pie",
        doughnut: "Doughnut",

        line: "Line",

        xyChart: "X Y (Scatter)",
        scatter: "Scatter",
        bubble: "Bubble",

        areaChart: "Area",
        area: "Area",
        stackedArea: "Stacked",
        normalizedArea: "100% Stacked",

        histogramChart: "Histogram",

        // Charts
        pivotChartTitle: "Pivot Chart",
        rangeChartTitle: "Range Chart",
        settings: "Settings",
        data: "Data",
        format: "Format",
        categories: "Categories",
        defaultCategory: "(None)",
        series: "Series",
        xyValues: "X Y Values",
        paired: "Paired Mode",
        axis: "Axis",
        navigator: "Navigator",
        color: "Color",
        thickness: "Thickness",
        xType: "X Type",
        automatic: "Automatic",
        category: "Category",
        number: "Number",
        time: "Time",
        xRotation: "X Rotation",
        yRotation: "Y Rotation",
        ticks: "Ticks",
        width: "Width",
        height: "Height",
        length: "Length",
        padding: "Padding",
        spacing: "Spacing",
        chart: "Chart",
        title: "Title",
        titlePlaceholder: "Chart title - double click to edit",
        background: "Background",
        font: "Font",
        top: "Top",
        right: "Right",
        bottom: "Bottom",
        left: "Left",
        labels: "Labels",
        size: "Size",
        minSize: "Minimum Size",
        maxSize: "Maximum Size",
        legend: "Legend",
        position: "Position",
        markerSize: "Marker Size",
        markerStroke: "Marker Stroke",
        markerPadding: "Marker Padding",
        itemSpacing: "Item Spacing",
        itemPaddingX: "Item Padding X",
        itemPaddingY: "Item Padding Y",
        layoutHorizontalSpacing: "Horizontal Spacing",
        layoutVerticalSpacing: "Vertical Spacing",
        strokeWidth: "Stroke Width",
        offset: "Offset",
        offsets: "Offsets",
        tooltips: "Tooltips",
        callout: "Callout",
        markers: "Markers",
        shadow: "Shadow",
        blur: "Blur",
        xOffset: "X Offset",
        yOffset: "Y Offset",
        lineWidth: "Line Width",
        normal: "Normal",
        bold: "Bold",
        italic: "Italic",
        boldItalic: "Bold Italic",
        predefined: "Predefined",
        fillOpacity: "Fill Opacity",
        strokeOpacity: "Line Opacity",
        histogramBinCount: "Bin count",
        columnGroup: "Column",
        barGroup: "Bar",
        pieGroup: "Pie",
        lineGroup: "Line",
        scatterGroup: "X Y (Scatter)",
        areaGroup: "Area",
        histogramGroup: "Histogram",
        groupedColumnTooltip: "Grouped",
        stackedColumnTooltip: "Stacked",
        normalizedColumnTooltip: "100% Stacked",
        groupedBarTooltip: "Grouped",
        stackedBarTooltip: "Stacked",
        normalizedBarTooltip: "100% Stacked",
        pieTooltip: "Pie",
        doughnutTooltip: "Doughnut",
        lineTooltip: "Line",
        groupedAreaTooltip: "Area",
        stackedAreaTooltip: "Stacked",
        normalizedAreaTooltip: "100% Stacked",
        scatterTooltip: "Scatter",
        bubbleTooltip: "Bubble",
        histogramTooltip: "Histogram",
        noDataToChart: "No data available to be charted.",
        pivotChartRequiresPivotMode: "Pivot Chart requires Pivot Mode enabled.",
      },

      // formsData:[{title:'ثبت خرید و فروش',icon:faBars,content:<BuySell />},{title:'ثبت واریز و برداشت',icon:faBars,content:<InOut aa={this.rage} ref={this.inout}/>},{title:'ثبت سود سهام تقسیم شده',icon:faBars,content:<DPS/>},{title:'ثبت افزایش سرمایه',icon:faBars,content:<CapitalIncrease/>},{title:'تبدیل حق تقدم به سهم',icon:faBars,content:<AdvanceRight/>},{title:'ثبت انتقال سهم بین سبدها',icon:faBars,content:<Transfer/>}]
    };

    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);

    this.scrolltobottomBasket = this.scrolltobottomBasket.bind(this);
    this.scrolltobottomBroker = this.scrolltobottomBroker.bind(this);

    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
    this.resetAllForm = this.resetAllForm.bind(this);

    this.tabcontainer = React.createRef();
    this.tabcontent = React.createRef();
    this.dashcharts = React.createRef();
    this.tabsTitlesContainer = React.createRef();
    this.dashboardd = React.createRef();
    this.brokercont = React.createRef();

    this.dashboardmenu = React.createRef();
    this.menuitems = React.createRef();
    this.dashboardContent = React.createRef();

    this.menuClick = this.menuClick.bind(this);

    this.calculateSelected = this.calculateSelected.bind(this);
    this.selectBasketAndBroker = this.selectBasketAndBroker.bind(this);

    this.DPSFormDiv = React.createRef();
    this.CapitalIncreaseDiv = React.createRef();
  }

  onSideMenuSelect(index, url) {
    this.setState(
      {
        sideMenuSelectedIndex: index,
        currentURL: url,
      },
      () => {
        if (this.state.width >= 1200)
          this.setState({
            top: this.sidebarItems[index].getBoundingClientRect().top + "px",
            left: this.dashboardContent.getBoundingClientRect().right + "px",
          });
        if (index !== 2) {
          if (this.state.selectedBrokerId !== 0) {
            this.setState({ selectedBrokerId: 0, brokerselectedindex: null });
          }

          if (index === 0)
            this.setState({ currentPortfolioFilter: "today" }, () => {
              this.getPortfolio(this.state.selectedPortfolioId, "last", false);
            });
        }
      }
    );
  }

  // componentDidUpdate(prevProps, prevState){
  //     if (prevState.tempChart1!==this.state.tempChart1){
  //         this.setState({selectedBasketChart1:this.state.tempChart1})
  //     }
  // }

  componentDidMount() {
    document.body.style.backgroundColor = "var(--white2)";
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    this.setState({ token: localStorage.getItem("token") });

    if (
      sessionStorage.getItem("description") !== undefined &&
      sessionStorage.getItem("description") !== null &&
      sessionStorage.getItem("description") !== ""
    ) {
      let nvt = sessionStorage.getItem("description").split("\n");
      this.setState({ newVersion: true, ModalShow: true, newVersionText: nvt });
    }

    this.getProfileData();
    this.setState({
      sideMenuSelectedIndex: 0,
    });

    window.scrollTo(0, 0);
  }

  getUserBrokers() {
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
    };

    fetch("/api/brokerList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          let arr = resultt.result;
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].status === 3) {
              arr.splice(i, 1);
              i--;
            }
          }

          if (arr.length === 0) {
            this.props.history.push("/Steps/Brokers");
          }

          if (
            this.state.brokerselectedindex !== null &&
            this.state.brokerselectedindex > arr.length - 1
          ) {
            this.setState(
              { brokerselectedindex: null, selectedBrokerId: 0 },
              () => {
                if (this.state.width >= 1200 && this.state.serverResponse) {
                  if (this.state.brokerselectedindex === null) {
                    this.inOutForm.setBrokerValue("", false);
                    this.buySellForm.setBrokerValue("", false);
                    this.capitalIncreaseForm.setBrokerValue("", false);
                    this.advanceRightForm.setBrokerValue("", false);
                    this.BrokerBenefitForm.setBrokerValue("", false);
                    this.ImportExcelForm.setBrokerValue("", false);
                    this.transferForm.setBrokerValue("", false);
                    this.BrokerCreditForm.setBrokerValue("", false);
                  }
                }
              }
            );
          } else {
            if (this.state.width >= 1200 && this.state.serverResponse) {
              if (this.state.brokerselectedindex === null) {
                this.inOutForm.setBrokerValue("", false);
                this.buySellForm.setBrokerValue("", false);
                this.capitalIncreaseForm.setBrokerValue("", false);
                this.advanceRightForm.setBrokerValue("", false);
                this.BrokerBenefitForm.setBrokerValue("", false);
                this.ImportExcelForm.setBrokerValue("", false);
                this.transferForm.setBrokerValue("", false);
                this.BrokerCreditForm.setBrokerValue("", false);
              }
            }
          }

          this.setState({ userBrokersData: arr });
          this.getUserBaskets();
        } else {
          this.props.history.push("/Login");
        }
      });
  }

  getUserBaskets() {
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
    };

    fetch("/api/basketList", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          let sumBalance = 0;
          resultt.result.forEach((element) => {
            sumBalance += element.balance;
          });
          let arr = resultt.result;
          for (var i = 0; i < arr.length; i++) {
            if (arr[i].status === 3) {
              arr.splice(i, 1);
              i--;
            }
          }
          if (arr.length === 0) {
            this.props.history.push("/Steps/Baskets");
          }
          this.setState(
            { userBasketsData: arr, userBasketsDataMain: arr },
            () => {
              if (resultt.result.length > 1) {
                this.setState(
                  {
                    userBasketsData: [
                      {
                        id: 0,
                        user_id: null,
                        lable: "کل سبدها",
                        balance: sumBalance,
                        status: 2,
                      },
                      ...this.state.userBasketsData,
                    ],
                  },
                  () => {
                    if (this.state.userBasketsData.length > 0) {
                      if (
                        this.state.tabselectedindex >
                        this.state.userBasketsData.length - 1
                      ) {
                        this.setState(
                          {
                            tabselectedindex:
                              this.state.userBasketsData.length - 1,
                          },
                          () => {
                            this.basketItemClicked(
                              this.state.tabselectedindex,
                              this.state.userBasketsData[
                                this.state.tabselectedindex
                              ].id,
                              this.state.userBasketsData[
                                this.state.tabselectedindex
                              ].lable,
                              this.state.userBasketsData[
                                this.state.tabselectedindex
                              ].percent
                            );
                          }
                        );
                      } else {
                        this.basketItemClicked(
                          this.state.tabselectedindex,
                          this.state.userBasketsData[
                            this.state.tabselectedindex
                          ].id,
                          this.state.userBasketsData[
                            this.state.tabselectedindex
                          ].lable,
                          this.state.userBasketsData[
                            this.state.tabselectedindex
                          ].percent
                        );
                      }
                    }
                  }
                );
              } else {
                if (this.state.userBasketsData.length > 0) {
                  if (
                    this.state.tabselectedindex >
                    this.state.userBasketsData.length - 1
                  ) {
                    this.setState(
                      {
                        tabselectedindex: this.state.userBasketsData.length - 1,
                      },
                      () => {
                        this.basketItemClicked(
                          this.state.tabselectedindex,
                          this.state.userBasketsData[
                            this.state.tabselectedindex
                          ].id,
                          this.state.userBasketsData[
                            this.state.tabselectedindex
                          ].lable,
                          this.state.userBasketsData[
                            this.state.tabselectedindex
                          ].percent
                        );
                      }
                    );
                  } else {
                    this.basketItemClicked(
                      this.state.tabselectedindex,
                      this.state.userBasketsData[this.state.tabselectedindex]
                        .id,
                      this.state.userBasketsData[this.state.tabselectedindex]
                        .lable,
                      this.state.userBasketsData[this.state.tabselectedindex]
                        .percent
                    );
                  }
                }
              }
            }
          );
        } else {
          // this.props.history.push('/Login');
        }
      });
  }

  getProfileData() {
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
    };

    fetch("/api/readPersonalInfo", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          if (
            resultt.result[0].profile_pic !== null &&
            resultt.result[0].profile_pic !== "broken.png" &&
            resultt.result[0].profile_pic !== "avatar.png"
          ) {
            this.setState({
              profilePicture: "/api/public/" + resultt.result[0].profile_pic,
            });
          } else if (resultt.result[0].profile_pic === "avatar.png") {
            if (this.state.width < 1200)
              this.setState({ profilePicture: avatarBlue });
            else this.setState({ profilePicture: avatarWhite });
          }

          let fullname = "";
          if (
            resultt.result[0].first_name !== null &&
            resultt.result[0].first_name !== undefined &&
            resultt.result[0].first_name !== ""
          ) {
            fullname = resultt.result[0].first_name;
          }

          if (
            resultt.result[0].last_name !== null &&
            resultt.result[0].last_name !== undefined &&
            resultt.result[0].last_name !== ""
          ) {
            fullname += " " + resultt.result[0].last_name;
          }

          this.setState({ userFullName: fullname });
          this.getUserBrokers();
        } else {
          this.props.history.push("/Login");
        }
      })
      .catch((err) => {});
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    try {
      this.setState({ width: window.innerWidth, height: window.innerHeight });
      // document.title=window.innerWidth.toString();
      if (this.state.serverResponse && this.state.width >= 1200)
        this.setState({
          top:
            this.sidebarItems[
              this.state.sideMenuSelectedIndex
            ].getBoundingClientRect().top + "px",
          left: this.dashboardContent.getBoundingClientRect().right + "px",
          profilePicture: avatarWhite,
          FormMenuVisible: false,
        });

      if (this.state.serverResponse && this.state.width < 1200)
        this.setState({ profilePicture: avatarBlue });
    } catch (error) {}
  }

  basketItemClicked(index, id, name, percent) {
    // console.log(index+"_"+id+"_"+name+"_"+percent)
    // if (this.state.serverResponse && this.state.userBasketsData.length<2) return;
    // if (this.state.serverResponse && this.state.selectedPortfolioId===id) return;
    this.setState(
      {
        tabselectedindex: index,
        selectedPortfolioId: id,
        selectedPortfolioName: name,
        selectedPortfolioPercent: percent,
      },
      () => {
        if (this.state.serverResponse) {
          let readonly = false;
          if (this.state.userBasketsData.length === 1) readonly = true;
          if (this.state.width >= 1200) {
            if (id === 0) {
              this.inOutForm.setBasketValue("", false);
              this.buySellForm.setBasketValue("", false);
              this.DPSForm.setBasketValue("", false);
              this.capitalIncreaseForm.setBasketValue("", false);
              this.advanceRightForm.setBasketValue("", false);
              this.BrokerBenefitForm.setBasketValue("", false);
              this.BrokerCreditForm.setBasketValue("", false);
              this.ImportExcelForm.setBasketValue("", false);
            } else {
              this.inOutForm.setBasketValue(name, readonly);
              this.buySellForm.setBasketValue(name, readonly);
              this.DPSForm.setBasketValue(name, readonly);
              this.capitalIncreaseForm.setBasketValue(name, readonly);
              this.advanceRightForm.setBasketValue(name, readonly);
              this.BrokerBenefitForm.setBasketValue(name, readonly);
              this.BrokerCreditForm.setBasketValue(name, readonly);
              this.ImportExcelForm.setBasketValue(name, readonly);
            }
          }
        }

        if (
          this.state.brokerselectedindex !== null &&
          this.state.userBasketsData.length > 1 &&
          index > 0
        ) {
          this.setState(
            { brokerselectedindex: null, selectedBrokerId: 0 },
            () => {
              switch (this.state.sideMenuSelectedIndex) {
                case 0: {
                  this.getPortfolio(id, this.state.currentPotfolioType, false);
                  break;
                }
                case 2: {
                  this.turnoverPage.getTurnoverData(
                    this.state.selectedBrokerId,
                    id
                  );
                  break;
                }
                case 1: {
                  this.chartPage.chartFileterByDate();
                  break;
                }
                case 3: {
                  this.profitPage.Twrr();
                  break;
                }
                default:
                  break;
              }
            }
          );
        } else {
          switch (this.state.sideMenuSelectedIndex) {
            case 0: {
              this.getPortfolio(id, this.state.currentPotfolioType, false);
              break;
            }
            case 2: {
              // console.log("8");
              this.turnoverPage.getTurnoverData(
                this.state.selectedBrokerId,
                id
              );
              break;
            }
            case 1: {
              this.chartPage.chartFileterByDate();
              break;
            }
            case 3: {
              this.profitPage.Twrr();
              break;
            }
            default:
              break;
          }
        }

        // console.log("selected index: " + this.state.sideMenuSelectedIndex);
      }
    );
  }

  brokerClick(index, id, name, full_name) {
    if (this.state.sideMenuSelectedIndex !== 2) {
      this.setState({ sideMenuSelectedIndex: 2 });
      if (this.state.width >= 1200)
        this.setState({
          top: this.sidebarItems[2].getBoundingClientRect().top + "px",
          left: this.dashboardContent.getBoundingClientRect().right + "px",
        });
      this.props.history.push("/Turnover");
    }
    if (this.state.userBrokersData.length < 2) return;
    if (this.state.brokerselectedindex === index) {
      this.setState({ brokerselectedindex: null, selectedBrokerId: 0 });
      if (this.state.sideMenuSelectedIndex === 0)
        this.basketItemClicked(0, 0, "", null);
      else if (this.state.sideMenuSelectedIndex === 2)
        this.turnoverPage.getTurnoverData(0, 0);
      if (this.state.width >= 1200) {
        this.inOutForm.setBrokerValue("", false);
        this.buySellForm.setBrokerValue("", false);
        this.capitalIncreaseForm.setBrokerValue("", false);
        this.advanceRightForm.setBrokerValue("", false);
        this.BrokerBenefitForm.setBrokerValue("", false);
        this.ImportExcelForm.setBrokerValue("", false);
        this.transferForm.setBrokerValue("", false);
        this.BrokerCreditForm.setBrokerValue("", false);
      }
    } else {
      this.setState({ brokerselectedindex: index, selectedBrokerId: id });
      if (this.state.userBasketsData.length > 1) {
        this.setState({
          tabselectedindex: 0,
          selectedPortfolioId: 0,
          selectedPortfolioName: "کل سبدها",
          brokerselectedindex: index,
          selectedBrokerId: id,
        });
        if (this.state.sideMenuSelectedIndex === 2)
          this.turnoverPage.getTurnoverData(id, 0);
      } else {
        // this.basketItemClicked(this.state.tabselectedindex,this.state.userBasketsData[this.state.tabselectedindex].id,this.state.userBasketsData[this.state.tabselectedindex].lable,this.state.userBasketsData[this.state.tabselectedindex].percent)
        this.setState({
          tabselectedindex: 0,
          selectedPortfolioId: this.state.userBasketsData[0].id,
          selectedPortfolioName: this.state.userBasketsData[0].lable,
          brokerselectedindex: index,
          selectedBrokerId: id,
        });
        if (this.state.sideMenuSelectedIndex === 2)
          this.turnoverPage.getTurnoverData(id, 0);
      }
      if (this.state.width >= 1200) {
        this.inOutForm.setBrokerValue(full_name, false);
        this.BrokerCreditForm.setBrokerValue(full_name, false);
        this.buySellForm.setBrokerValue(full_name, false);
        this.capitalIncreaseForm.setBrokerValue(full_name, false);
        this.advanceRightForm.setBrokerValue(full_name, false);
        this.BrokerBenefitForm.setBrokerValue(full_name, false);
        this.ImportExcelForm.setBrokerValue(full_name, false);
        this.transferForm.setBrokerValue(full_name, false);
      }
    }
  }

  getPortfolio(id, type, xls) {
    this.setState({ currentPotfolioType: type });
    let data;
    let apiName;

    if (id === 0) {
      data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        type: type,
        date: this.state.currentPortfolioFilter,
        toXls: xls,
      };
      apiName = "totalPortfolio";
    } else {
      data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        basket_id: id,
        type: type,
        date: this.state.currentPortfolioFilter,
        toXls: xls,
      };
      apiName = "portfolio";
    }
    if (
      this.state.serverResponse &&
      !this.state.silentRefresh &&
      this.dashboardPage !== undefined &&
      this.dashboardPage !== null
    )
      this.dashboardPage.setLoadingOn();
    fetch("/api/" + apiName, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          let arr = resultt.result;

          for (var i = 0; i < arr.length; i++) {
            if (arr[i].quantity === 0) {
              arr.splice(i, 1);
              i--;
            }
          }

          this.setState({ selectedPortfolio: arr });
          this.setState({ selectedBasketChart3: resultt.total_result });
          // console.log(resultt.total_result);

          if (arr.length === 0) {
            this.getTransactionCount(id);
            return;
          }

          this.getIndustryPortfolio(id, type);
        } else {
          this.props.history.push("/Login");
        }
      });
  }

  getTransactionCount(id) {
    let data = {
      mobile: localStorage.getItem("mobile"),
      token: localStorage.getItem("token"),
      basket_id: id,
    };
    fetch("/api/countTransaction", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        if (resultt.status === 200) {
          // let arr=resultt.result.cot;
          if (resultt.cot > 0) {
            this.setState({ dashboardHasTransaction: true });
          } else {
            this.setState({ dashboardHasTransaction: false });
          }

          this.setState({ serverResponse: true }, () => {
            this.startTimer();
            if (this.state.width >= 1200)
              this.setState({
                top:
                  this.sidebarItems[
                    this.state.sideMenuSelectedIndex
                  ].getBoundingClientRect().top + "px",
                left:
                  this.dashboardContent.getBoundingClientRect().right + "px",
              });

            if (this.state.userBasketsData.length === 1) {
              if (this.state.width >= 1200) {
                this.inOutForm.setBasketValue(
                  this.state.userBasketsData[0].lable,
                  true
                );
                this.buySellForm.setBasketValue(
                  this.state.userBasketsData[0].lable,
                  true
                );
                this.DPSForm.setBasketValue(
                  this.state.userBasketsData[0].lable,
                  true
                );
                this.capitalIncreaseForm.setBasketValue(
                  this.state.userBasketsData[0].lable,
                  true
                );
                this.advanceRightForm.setBasketValue(
                  this.state.userBasketsData[0].lable,
                  true
                );
                this.BrokerBenefitForm.setBasketValue(
                  this.state.userBasketsData[0].lable,
                  true
                );
                this.BrokerCreditForm.setBasketValue(
                  this.state.userBasketsData[0].lable,
                  true
                );
                this.ImportExcelForm.setBasketValue(
                  this.state.userBasketsData[0].lable,
                  true
                );
              }
            }

            if (this.state.userBrokersData.length === 1) {
              if (this.state.width >= 1200) {
                this.inOutForm.setBrokerValue(
                  this.state.userBrokersData[0].full_name,
                  true
                );
                this.BrokerCreditForm.setBrokerValue(
                  this.state.userBrokersData[0].full_name,
                  true
                );
                this.buySellForm.setBrokerValue(
                  this.state.userBrokersData[0].full_name,
                  true
                );
                this.capitalIncreaseForm.setBrokerValue(
                  this.state.userBrokersData[0].full_name,
                  true
                );
                this.advanceRightForm.setBrokerValue(
                  this.state.userBrokersData[0].full_name,
                  true
                );
                this.BrokerBenefitForm.setBrokerValue(
                  this.state.userBrokersData[0].full_name,
                  true
                );
                this.ImportExcelForm.setBrokerValue(
                  this.state.userBrokersData[0].full_name,
                  true
                );
                this.transferForm.setBrokerValue(
                  this.state.userBrokersData[0].full_name,
                  true
                );
              }
            }
            if (
              this.state.serverResponse &&
              !this.state.silentRefresh &&
              this.dashboardPage !== undefined &&
              this.dashboardPage !== null
            )
              this.dashboardPage.setLoadingOff();
            this.setState({ silentRefresh: false });
          });
        } else {
          this.props.history.push("/Login");
        }
      });
  }

  getIndustryPortfolio(id, type) {
    let data;
    let apiName;

    if (id === 0) {
      data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        type: type,
        date: this.state.currentPortfolioFilter,
      };
      apiName = "totalIndustryPortfolio";
    } else {
      data = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        basket_id: id,
        type: type,
        date: this.state.currentPortfolioFilter,
      };
      apiName = "industryPortfolio";
    }

    fetch("/api/" + apiName, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((resultt) => {
        try {
          if (resultt.status === 200) {
            if (this.state.selectedBasketChart1 !== resultt.result) {
              this.setState({ selectedBasketChart1: resultt.result });
            }

            this.setState({ serverResponse: true }, () => {
              this.startTimer();
              if (this.state.width >= 1200)
                this.setState({
                  top:
                    this.sidebarItems[
                      this.state.sideMenuSelectedIndex
                    ].getBoundingClientRect().top + "px",
                  left:
                    this.dashboardContent.getBoundingClientRect().right + "px",
                });

              if (this.state.userBasketsData.length === 1) {
                if (this.state.width >= 1200) {
                  this.inOutForm.setBasketValue(
                    this.state.userBasketsData[0].lable,
                    true
                  );
                  this.buySellForm.setBasketValue(
                    this.state.userBasketsData[0].lable,
                    true
                  );
                  this.DPSForm.setBasketValue(
                    this.state.userBasketsData[0].lable,
                    true
                  );
                  this.capitalIncreaseForm.setBasketValue(
                    this.state.userBasketsData[0].lable,
                    true
                  );
                  this.advanceRightForm.setBasketValue(
                    this.state.userBasketsData[0].lable,
                    true
                  );
                  this.BrokerBenefitForm.setBasketValue(
                    this.state.userBasketsData[0].lable,
                    true
                  );
                  this.BrokerCreditForm.setBasketValue(
                    this.state.userBasketsData[0].lable,
                    true
                  );
                  this.ImportExcelForm.setBasketValue(
                    this.state.userBasketsData[0].lable,
                    true
                  );
                }
              }

              if (this.state.userBrokersData.length === 1) {
                if (this.state.width >= 1200) {
                  this.inOutForm.setBrokerValue(
                    this.state.userBrokersData[0].full_name,
                    true
                  );
                  this.BrokerCreditForm.setBrokerValue(
                    this.state.userBrokersData[0].full_name,
                    true
                  );
                  this.buySellForm.setBrokerValue(
                    this.state.userBrokersData[0].full_name,
                    true
                  );
                  this.capitalIncreaseForm.setBrokerValue(
                    this.state.userBrokersData[0].full_name,
                    true
                  );
                  this.advanceRightForm.setBrokerValue(
                    this.state.userBrokersData[0].full_name,
                    true
                  );
                  this.BrokerBenefitForm.setBrokerValue(
                    this.state.userBrokersData[0].full_name,
                    true
                  );
                  this.ImportExcelForm.setBrokerValue(
                    this.state.userBrokersData[0].full_name,
                    true
                  );
                  this.transferForm.setBrokerValue(
                    this.state.userBrokersData[0].full_name,
                    true
                  );
                }
              }
              if (
                this.state.serverResponse &&
                !this.state.silentRefresh &&
                this.dashboardPage !== undefined &&
                this.dashboardPage !== null
              )
                this.dashboardPage.setLoadingOff();
              this.setState({ silentRefresh: false });
            });
          } else {
            this.props.history.push("/Login");
          }
        } catch (error) {
          if (
            this.state.serverResponse &&
            !this.state.silentRefresh &&
            this.dashboardPage !== undefined &&
            this.dashboardPage !== null
          )
            this.dashboardPage.setLoadingOff();
          this.setState({ silentRefresh: false });
        }
      });
  }

  // getIndustryPortfolioByBroker(id,type){
  //     let data = {
  //             mobile: localStorage.getItem("mobile"),
  //             token:localStorage.getItem("token"),
  //             broker_id:id,
  //             type:type,
  //             date:this.state.currentPortfolioFilter
  //         };

  //     fetch("/api/industryPortfolioByBroker",{
  //         method: 'POST',
  //         headers: { 'Content-Type': 'application/json' },
  //         body: JSON.stringify(data)
  //     })
  //     .then(res => res.json())
  //     .then(
  //     (resultt) => {
  //         if (resultt.status===200){
  //             this.setState({selectedBasketChart1:resultt.result});
  //             // this.setState({selectedBasketChart3:resultt.total_result});
  //         }else{
  //             this.props.history.push('/Login');
  //         }
  //     }
  //     )
  // }

  menuClick() {
    this.setState((preState) => {
      return { menuOpen: !preState.menuOpen };
    });
  }

  onProfileClick() {
    this.setState({
      shareBasket: false,
      archiveBroker: false,
      addBasket: false,
      editBasket: false,
      editBroker: false,
      editProfile: true,
      addBroker: false,
      ModalShow: true,
    });
  }

  hideModal() {
    if (
      this.state.editBasket ||
      this.state.editBroker ||
      this.state.deleteTransaction ||
      this.state.editProfile
    ) {
      this.getUserBrokers();
    }

    this.setState({
      increaseActionError: "",
      newVersion: false,
      twrrMessage: false,
      mwrrMessage: false,
      editProfile: false,
      ModalShow: false,
      deleteTransaction: false,
      dpsSuggestion: false,
      increaseSuggestion: false,
      archiveBasket: false,
      shareBaskett: false,
      editBasket: false,
      editBroker: false,
      FormMenuVisible: false,
      inoutPopup: false,
      buysellPopup: false,
      dpsPopup: false,
      capitalincreasePopup: false,
      advancerightPopup: false,
      brokerbenefitPopup: false,
      brokercreditPopup: false,
      importexcelPopup: false,
      transferPopup: false,
      archiveBroker: false,
    });

    // if (this.state.dpsSuggestion && this.state.increaseSuggestion && && this.state.increaseSuggestion)
    if (this.state.width >= 1200) {
      this.inOutForm.resetForm();
      this.buySellForm.resetForm();
      this.DPSForm.resetForm();
      this.capitalIncreaseForm.resetForm();
      this.advanceRightForm.resetForm();
      this.BrokerBenefitForm.resetForm();
      this.ImportExcelForm.resetForm();
      this.transferForm.resetForm();
    }

    // this.selectBasketAndBroker();
  }

  calculateSelected() {
    if (this.state.tabselectedindex > this.state.userBasketsData.length) {
      this.setState(
        { tabselectedindex: this.state.userBasketsData.length - 1 },
        () => {
          this.selectBasketAndBroker();
        }
      );
    } else if (
      this.state.brokerselectedindex > this.state.userBrokersData.length
    ) {
      this.setState(
        { brokerselectedindex: this.state.userBrokersData.length - 1 },
        () => {
          this.selectBasketAndBroker();
        }
      );
    }
  }

  selectBasketAndBroker() {
    if (Number(this.state.selectedPortfolioId) !== 0)
      this.inOutForm.setBasketValue(this.state.selectedPortfolioName, false);
    if (this.state.brokerselectedindex !== null)
      this.inOutForm.setBrokerValue(
        this.state.userBrokersData[this.state.brokerselectedindex].full_name,
        false
      );
    else if (this.state.userBrokersData.length === 1)
      this.inOutForm.setBrokerValue(
        this.state.userBrokersData[0].full_name,
        true
      );

    if (Number(this.state.selectedPortfolioId) !== 0)
      this.buySellForm.setBasketValue(this.state.selectedPortfolioName, false);
    if (this.state.brokerselectedindex !== null)
      this.buySellForm.setBrokerValue(
        this.state.userBrokersData[this.state.brokerselectedindex].full_name,
        false
      );
    else if (this.state.userBrokersData.length === 1)
      this.buySellForm.setBrokerValue(
        this.state.userBrokersData[0].full_name,
        true
      );

    if (Number(this.state.selectedPortfolioId) !== 0)
      this.DPSForm.setBasketValue(this.state.selectedPortfolioName, false);

    if (Number(this.state.selectedPortfolioId) !== 0)
      this.BrokerBenefitForm.setBasketValue(
        this.state.selectedPortfolioName,
        false
      );
    if (this.state.brokerselectedindex !== null)
      this.BrokerBenefitForm.setBrokerValue(
        this.state.userBrokersData[this.state.brokerselectedindex].full_name,
        false
      );
    else if (this.state.userBrokersData.length === 1)
      this.BrokerBenefitForm.setBrokerValue(
        this.state.userBrokersData[0].full_name,
        true
      );

    if (Number(this.state.selectedPortfolioId) !== 0)
      this.BrokerCreditForm.setBasketValue(
        this.state.selectedPortfolioName,
        false
      );
    if (this.state.brokerselectedindex !== null)
      this.BrokerCreditForm.setBrokerValue(
        this.state.userBrokersData[this.state.brokerselectedindex].full_name,
        false
      );
    else if (this.state.userBrokersData.length === 1)
      this.BrokerCreditForm.setBrokerValue(
        this.state.userBrokersData[0].full_name,
        true
      );

    if (Number(this.state.selectedPortfolioId) !== 0)
      this.capitalIncreaseForm.setBasketValue(
        this.state.selectedPortfolioName,
        false
      );
    if (this.state.brokerselectedindex !== null)
      this.capitalIncreaseForm.setBrokerValue(
        this.state.userBrokersData[this.state.brokerselectedindex].full_name,
        false
      );
    else if (this.state.userBrokersData.length === 1)
      this.capitalIncreaseForm.setBrokerValue(
        this.state.userBrokersData[0].full_name,
        true
      );

    if (Number(this.state.selectedPortfolioId) !== 0)
      this.advanceRightForm.setBasketValue(
        this.state.selectedPortfolioName,
        false
      );
    if (this.state.brokerselectedindex !== null)
      this.advanceRightForm.setBrokerValue(
        this.state.userBrokersData[this.state.brokerselectedindex].full_name,
        false
      );
    else if (this.state.userBrokersData.length === 1)
      this.advanceRightForm.setBrokerValue(
        this.state.userBrokersData[0].full_name,
        true
      );

    if (Number(this.state.selectedPortfolioId) !== 0)
      this.ImportExcelForm.setBasketValue(
        this.state.selectedPortfolioName,
        false
      );
    if (this.state.brokerselectedindex !== null)
      this.ImportExcelForm.setBrokerValue(
        this.state.userBrokersData[this.state.brokerselectedindex].full_name,
        false
      );
    else if (this.state.userBrokersData.length === 1)
      this.ImportExcelForm.setBrokerValue(
        this.state.userBrokersData[0].full_name,
        true
      );
  }

  onLogoutClick() {
    sessionStorage.clear();
    localStorage.clear();
    return;
    // this.props.history.push("/Login");
  }

  addBrokerButton() {
    this.setState({
      shareBasket: false,
      archiveBroker: false,
      addBasket: false,
      editBasket: false,
      editBroker: true,
      editProfile: false,
      addBroker: false,
      ModalShow: true,
    });
  }

  addBrokerYES() {
    this.setState((previousState) => ({
      userBrokersData: [
        ...previousState.userBrokersData,
        {
          id: this.makeid(5),
          name: this.addBrokerText.value,
          description: "",
          price: "0",
          logo: "https://mofidonline.com/Themes/mofid/Fa/images/MobileViewLogo.png",
        },
      ],
    }));
    this.hideModal();
  }

  editBasketButton() {
    this.setState({
      shareBasket: false,
      archiveBroker: false,
      addBroker: false,
      editBasket: true,
      editBroker: false,
      editProfile: false,
      addBasket: false,
      ModalShow: true,
    });
  }

  archiveBroker(index, id, name) {
    this.setState({
      shareBasket: false,
      archiveBroker: true,
      addBroker: false,
      editBasket: false,
      editBroker: false,
      addBasket: false,
      ModalShow: true,
      archiveBrokerId: id,
      archiveBrokerName: name,
    });
  }

  archiveBrokerYES() {
    var index = this.state.userBrokersData.findIndex(
      (e) => e.id === this.state.archiveBrokerId
    );
    var newAray = this.state.userBrokersData.slice();
    newAray.splice(index, 1);
    this.setState({ userBrokersData: newAray, ModalShow: false });
  }

  archiveBrokerNO() {
    this.setState({ editBroker: true, archiveBroker: false });
  }

  archiveBasket(index, id, name) {
    this.setState({
      shareBasket: false,
      archiveBroker: true,
      addBroker: false,
      editBasket: false,
      editBroker: false,
      addBasket: false,
      ModalShow: true,
      archiveBrokerId: id,
      archiveBrokerName: name,
    });
  }

  archiveBasketYES() {
    var index = this.state.userBasketsData.findIndex(
      (e) => e.id === this.state.archiveBasketId
    );
    var newAray = this.state.userBasketsData.slice();
    newAray.splice(index, 1);

    var index1 = this.state.userBasketsDataMain.findIndex(
      (e) => e.id === this.state.archiveBasketId
    );
    var newAray1 = this.state.userBasketsDataMain.slice();
    newAray1.splice(index1, 1);

    this.setState({
      userBasketsData: newAray,
      userBasketsDataMain: newAray1,
      editBasket: true,
      archiveBasket: false,
    });
  }

  archiveBasketNO() {
    this.setState({ editBasket: true, archiveBasket: false });
  }

  editBroker(index, id) {}

  // deleteBasketItem(id,name){
  //     this.setState({ editBasket:false,archiveBasket:true,modalBackDrop:'static',archiveBasketId:id,archiveBasketName:name });
  // }

  editBasketItem(id, name, des) {}

  shareBasketItem() {
    this.setState({ editBasket: false, shareBaskett: true });
  }

  scrolltobottomBasket() {
    this.itemscontainerBasket.scrollTop =
      this.itemscontainerBasket.scrollHeight + 200;
  }

  shareBasketYES() {
    this.setState({ editBasket: true, shareBaskett: false });
  }

  shareBasketNO() {
    this.setState({ editBasket: true, shareBaskett: false });
  }

  // deleteBrokerItem(id,name){
  //     this.setState({ editBroker:false,archiveBroker:true,modalBackDrop:'static',archiveBrokerId:id,archiveBrokerName:name });
  // }

  editBrokerItem(id, name, des) {}

  // addBrokerItem(id,name,des){
  //     this.setState(previousState => ({
  //         userBrokersData: [...previousState.userBrokersData, {id:id,broker_name:name,description:des}]
  //     }));

  //     setTimeout(this.scrolltobottomBroker, 10);
  // }

  scrolltobottomBroker() {
    this.itemscontainerBroker.scrollTop =
      this.itemscontainerBroker.scrollHeight + 200;
  }

  profileSave(img) {
    this.setState({ profilePicture: img });
    this.hideModal();
  }

  turnoverPageIsOpen() {
    this.setState(
      {
        sideMenuSelectedIndex: 2,
      },
      () => {
        if (this.state.width >= 1200)
          this.setState({
            top:
              this.sidebarItems[
                this.state.sideMenuSelectedIndex
              ].getBoundingClientRect().top + "px",
            left: this.dashboardContent.getBoundingClientRect().right + "px",
          });
      }
    );
  }

  chartPageIsOpen() {
    this.setState(
      {
        sideMenuSelectedIndex: 1,
      },
      () => {
        if (this.state.width >= 1200)
          this.setState({
            top:
              this.sidebarItems[
                this.state.sideMenuSelectedIndex
              ].getBoundingClientRect().top + "px",
            left: this.dashboardContent.getBoundingClientRect().right + "px",
          });
      }
    );
  }

  profitPageIsOpen() {
    this.setState(
      {
        sideMenuSelectedIndex: 3,
      },
      () => {
        if (this.state.width >= 1200)
          this.setState({
            top:
              this.sidebarItems[
                this.state.sideMenuSelectedIndex
              ].getBoundingClientRect().top + "px",
            left: this.dashboardContent.getBoundingClientRect().right + "px",
          });
      }
    );
  }

  dashboardPageIsOpen() {
    this.setState(
      {
        sideMenuSelectedIndex: 0,
      },
      () => {
        if (this.state.width >= 1200)
          this.setState({
            top:
              this.sidebarItems[
                this.state.sideMenuSelectedIndex
              ].getBoundingClientRect().top + "px",
            left: this.dashboardContent.getBoundingClientRect().right + "px",
          });
      }
    );
  }

  onSiteClick() {}

  accordionOpen(state) {
    if (state === "buysell") {
      if (this.state.width >= 1200) {
        this.setState({
          InOutState: false,
          BuySellState: true,
          DPSState: false,
          CapitalIncreaseState: false,
          AdvanceRightState: false,
          BrokerBenefitState: false,
          BrokerCreditState: false,
          ImportExcelState: false,
          TransferState: false,
        });
      } else {
        this.setState({ buysellPopup: true, ModalShow: true }, () => {
          if (Number(this.state.selectedPortfolioId) !== 0)
            this.buySellForm.setBasketValue(
              this.state.selectedPortfolioName,
              false
            );
          if (this.state.brokerselectedindex !== null)
            this.buySellForm.setBrokerValue(
              this.state.userBrokersData[this.state.brokerselectedindex]
                .full_name,
              false
            );
          else if (this.state.userBrokersData.length === 1)
            this.buySellForm.setBrokerValue(
              this.state.userBrokersData[0].full_name,
              true
            );
        });
      }
    } else if (state === "inout") {
      if (this.state.width >= 1200) {
        this.setState({
          InOutState: true,
          BuySellState: false,
          DPSState: false,
          CapitalIncreaseState: false,
          AdvanceRightState: false,
          BrokerBenefitState: false,
          BrokerCreditState: false,
          ImportExcelState: false,
          TransferState: false,
        });
      } else {
        this.setState({ inoutPopup: true, ModalShow: true }, () => {
          if (Number(this.state.selectedPortfolioId) !== 0)
            this.inOutForm.setBasketValue(
              this.state.selectedPortfolioName,
              false
            );
          if (this.state.brokerselectedindex !== null)
            this.inOutForm.setBrokerValue(
              this.state.userBrokersData[this.state.brokerselectedindex]
                .full_name,
              false
            );
          else if (this.state.userBrokersData.length === 1)
            this.inOutForm.setBrokerValue(
              this.state.userBrokersData[0].full_name,
              true
            );
        });
      }
    } else if (state === "excel") {
      if (this.state.width >= 1200) {
        this.setState({
          InOutState: false,
          BuySellState: false,
          DPSState: false,
          CapitalIncreaseState: false,
          AdvanceRightState: false,
          BrokerBenefitState: false,
          BrokerCreditState: false,
          ImportExcelState: true,
          TransferState: false,
        });
      } else {
        this.setState({ importexcelPopup: true, ModalShow: true }, () => {
          if (Number(this.state.selectedPortfolioId) !== 0)
            this.ImportExcelForm.setBasketValue(
              this.state.selectedPortfolioName,
              false
            );
          if (this.state.brokerselectedindex !== null)
            this.ImportExcelForm.setBrokerValue(
              this.state.userBrokersData[this.state.brokerselectedindex]
                .full_name,
              false
            );
          else if (this.state.userBrokersData.length === 1)
            this.ImportExcelForm.setBrokerValue(
              this.state.userBrokersData[0].full_name,
              true
            );
        });
      }
    }
  }

  InOutClicked() {
    this.setState({
      InOutState: !this.state.InOutState,
      BuySellState: false,
      DPSState: false,
      CapitalIncreaseState: false,
      AdvanceRightState: false,
      BrokerBenefitState: false,
      BrokerCreditState: false,
      ImportExcelState: false,
      TransferState: false,
    });
    this.resetAllForm();
  }

  BuySellClicked() {
    this.setState({
      InOutState: false,
      BuySellState: !this.state.BuySellState,
      DPSState: false,
      CapitalIncreaseState: false,
      AdvanceRightState: false,
      BrokerBenefitState: false,
      BrokerCreditState: false,
      ImportExcelState: false,
      TransferState: false,
    });
    this.resetAllForm();
  }

  DPSClicked() {
    this.setState({
      InOutState: false,
      BuySellState: false,
      DPSState: !this.state.DPSState,
      CapitalIncreaseState: false,
      AdvanceRightState: false,
      BrokerBenefitState: false,
      BrokerCreditState: false,
      ImportExcelState: false,
      TransferState: false,
    });
    this.resetAllForm();
  }

  CapitalIncreaseClicked() {
    this.setState({
      InOutState: false,
      BuySellState: false,
      DPSState: false,
      CapitalIncreaseState: !this.state.CapitalIncreaseState,
      AdvanceRightState: false,
      BrokerBenefitState: false,
      BrokerCreditState: false,
      ImportExcelState: false,
      TransferState: false,
    });
    this.resetAllForm();
  }

  AdvanceRightClicked() {
    this.setState({
      InOutState: false,
      BuySellState: false,
      DPSState: false,
      CapitalIncreaseState: false,
      AdvanceRightState: !this.state.AdvanceRightState,
      BrokerBenefitState: false,
      BrokerCreditState: false,
      ImportExcelState: false,
      TransferState: false,
    });
    this.resetAllForm();
  }

  BrokerBenefitClicked() {
    this.setState({
      InOutState: false,
      BuySellState: false,
      DPSState: false,
      CapitalIncreaseState: false,
      AdvanceRightState: false,
      BrokerBenefitState: !this.state.BrokerBenefitState,
      BrokerCreditState: false,
      ImportExcelState: false,
      TransferState: false,
    });
    this.resetAllForm();
  }

  BrokerCreditClicked() {
    this.setState({
      InOutState: false,
      BuySellState: false,
      DPSState: false,
      CapitalIncreaseState: false,
      AdvanceRightState: false,
      BrokerBenefitState: false,
      BrokerCreditState: !this.state.BrokerCreditState,
      ImportExcelState: false,
      TransferState: false,
    });
    this.resetAllForm();
  }

  TransferClicked() {
    if (this.state.userBasketsData.length < 2) return;
    this.setState({
      InOutState: false,
      BuySellState: false,
      DPSState: false,
      CapitalIncreaseState: false,
      AdvanceRightState: false,
      BrokerBenefitState: false,
      BrokerCreditState: false,
      ImportExcelState: false,
      TransferState: !this.state.TransferState,
    });
    this.resetAllForm();
  }

  ImportExcelClicked() {
    this.setState({
      InOutState: false,
      BuySellState: false,
      DPSState: false,
      CapitalIncreaseState: false,
      AdvanceRightState: false,
      BrokerBenefitState: false,
      BrokerCreditState: false,
      ImportExcelState: !this.state.ImportExcelState,
      TransferState: false,
    });
    this.resetAllForm();
  }

  resetAllForm() {
    if (this.state.width >= 1200) {
      this.inOutForm.resetForm();
      this.buySellForm.resetForm();
      this.DPSForm.resetForm();
      this.capitalIncreaseForm.resetForm();
      this.advanceRightForm.resetForm();
      this.BrokerBenefitForm.resetForm();
      this.ImportExcelForm.resetForm();
      this.transferForm.resetForm();
    }
  }

  onPageDataRefresh() {
    // if (this.state.sideMenuSelectedIndex===0){
    //     this.getUserBrokers();
    // }else{
    //     this.turnoverPage.getTurnoverData(this.state.selectedBrokerId,this.state.selectedPortfolioId);
    // }
    this.getUserBrokers();
  }

  startTimer() {
    clearInterval(this.timer);
    this.setState({ seconds: this.state.totalsecend });
    this.timer = setInterval(this.countDown, 1000);
  }

  countDown() {
    let secondss = this.state.seconds - 1;
    this.setState({ seconds: secondss });

    if (secondss === 0) {
      clearInterval(this.timer);
      this.setState({ silentRefresh: true }, () => {
        this.getPortfolio(
          this.state.selectedPortfolioId,
          this.state.currentPotfolioType,
          false
        );
      });
    }
  }

  showDPSSuggestion(suggestions, cost) {
    if (suggestions.length > 0) {
      let mysuggest = [];
      suggestions.forEach((element) => {
        let title = "";
        this.state.userBasketsData.forEach((element1) => {
          if (element1.id === element.basket_id) {
            title = element1.lable;
          }
        });

        let s = {
          id: element.basket_id,
          title: title,
          price: element.suggest,
          quantity: element.quantity,
        };
        mysuggest.push(s);
      });
      if (this.state.width < 1200) {
        this.DPSFormDiv.current.style.display = "none";
      }
      this.setState({
        dpsSuggestionResult: mysuggest,
        dpsSuggestion: true,
        ModalShow: true,
        dpsCost: cost,
      });
    }
  }

  dpsQuantityChange(id, value) {
    if (value === null || value === "" || value === undefined) value = 0;
    let res = value * this.state.dpsCost;
    let basket = this.state.dpsSuggestionResult.slice();
    basket.forEach(function (entry) {
      if (entry.id === id) {
        entry.quantity = value;
        entry.price = res;
      }
    });

    this.setState({ dpsSuggestionResult: basket });
  }

  submitDPSDevision() {
    let found = false;
    this.state.dpsSuggestionResult.forEach(function (entry) {
      if (
        entry.quantity === null ||
        entry.quantity === 0 ||
        entry.quantity === "" ||
        entry.quantity === undefined
      ) {
        found = true;
      }
    });
    if (found) {
      this.setState({ dpsActionError: "لطفاً تمام موارد را پر کنید" });
      return;
    }
    this.setState({ dpsButtonDisabled: true });
    this.DPSForm.suggestionSubmit(this.state.dpsSuggestionResult);
  }

  submitDPSDevisionSuccess() {
    this.setState({ dpsButtonDisabled: false });
    this.hideModal();
  }

  showIncreaseSuggestion(suggestions) {
    if (suggestions.length > 0) {
      let mysuggest = [];
      suggestions.forEach((element) => {
        let title = "";
        this.state.userBasketsData.forEach((element1) => {
          if (element1.id === element.basket_id) {
            title = element1.lable;
          }
        });

        let s = {
          id: element.basket_id,
          title: title,
          suggest: element.suggest,
          broker_id: null,
        };
        mysuggest.push(s);
      });
      if (this.state.width < 1200) {
        this.CapitalIncreaseDiv.current.style.display = "none";
      }
      this.setState({
        increaseSuggestionResult: mysuggest,
        increaseSuggestion: true,
        ModalShow: true,
      });
    }
  }

  increaseQuantityChange(id, value) {
    if (value === null || value === "" || value === undefined) value = 0;
    let basket = this.state.increaseSuggestionResult.slice();
    basket.forEach(function (entry) {
      if (entry.id === id) {
        entry.suggest = value;
      }
    });

    this.setState({ increaseSuggestionResult: basket });
  }

  increaseBrokerChange(id, value) {
    if (value === null || value === "" || value === undefined) value = 0;
    let basket = this.state.increaseSuggestionResult.slice();
    basket.forEach(function (entry) {
      if (entry.id === id) {
        entry.broker_id = value;
      }
    });

    this.setState({ increaseSuggestionResult: basket });
  }

  submitIncreaseDevision() {
    this.setState({ increaseActionError: "" });
    let found = false;
    this.state.increaseSuggestionResult.forEach(function (entry) {
      if (
        entry.broker_id === null ||
        entry.broker_id === 0 ||
        entry.broker_id === "" ||
        entry.broker_id === undefined ||
        entry.suggest === null ||
        entry.suggest === 0 ||
        entry.suggest === "" ||
        entry.suggest === undefined
      ) {
        found = true;
      }
    });
    if (found) {
      this.setState({ increaseActionError: "لطفاً تمام موارد را پر کنید" });
      return;
    }
    this.setState({ increaseButtonDisabled: true });
    this.capitalIncreaseForm.suggestionSubmit(
      this.state.increaseSuggestionResult
    );
  }

  submitIncreaseDevisionSuccess() {
    this.setState({ increaseButtonDisabled: false });
    this.hideModal();
  }

  editTransaction(data) {
    try {
      switch (data.type_id) {
        case 1: {
          if (this.state.width >= 1200) {
            this.setState({
              InOutState: true,
              BuySellState: false,
              DPSState: false,
              CapitalIncreaseState: false,
              AdvanceRightState: false,
              BrokerBenefitState: false,
              BrokerCreditState: false,
              ImportExcelState: false,
              TransferState: false,
            });
            this.inOutForm.editFrom(data);
          } else {
            this.setState({ inoutPopup: true, ModalShow: true }, () => {
              this.inOutForm.editFrom(data);
            });
          }
          break;
        }
        case 2: {
          if (this.state.width >= 1200) {
            this.setState({
              InOutState: true,
              BuySellState: false,
              DPSState: false,
              CapitalIncreaseState: false,
              AdvanceRightState: false,
              BrokerBenefitState: false,
              BrokerCreditState: false,
              ImportExcelState: false,
              TransferState: false,
            });
            this.inOutForm.editFrom(data);
          } else {
            this.setState({ inoutPopup: true, ModalShow: true }, () => {
              this.inOutForm.editFrom(data);
            });
          }
          break;
        }
        case 3: {
          if (this.state.width >= 1200) {
            this.setState({
              InOutState: false,
              BuySellState: true,
              DPSState: false,
              CapitalIncreaseState: false,
              AdvanceRightState: false,
              BrokerBenefitState: false,
              BrokerCreditState: false,
              ImportExcelState: false,
              TransferState: false,
            });
            this.buySellForm.editFrom(data);
          } else {
            this.setState({ buysellPopup: true, ModalShow: true }, () => {
              this.buySellForm.editFrom(data);
            });
          }
          break;
        }
        case 4: {
          if (this.state.width >= 1200) {
            this.setState({
              InOutState: false,
              BuySellState: true,
              DPSState: false,
              CapitalIncreaseState: false,
              AdvanceRightState: false,
              BrokerBenefitState: false,
              BrokerCreditState: false,
              ImportExcelState: false,
              TransferState: false,
            });
            this.buySellForm.editFrom(data);
          } else {
            this.setState({ buysellPopup: true, ModalShow: true }, () => {
              this.buySellForm.editFrom(data);
            });
          }

          break;
        }
        case 5: {
          if (this.state.width >= 1200) {
            this.setState({
              InOutState: false,
              BuySellState: false,
              DPSState: true,
              CapitalIncreaseState: false,
              AdvanceRightState: false,
              BrokerBenefitState: false,
              BrokerCreditState: false,
              ImportExcelState: false,
              TransferState: false,
            });
            this.DPSForm.editFrom(data);
          } else {
            this.setState({ dpsPopup: true, ModalShow: true }, () => {
              this.DPSForm.editFrom(data);
            });
          }

          break;
        }
        case 6: {
          if (this.state.width >= 1200) {
            this.setState({
              InOutState: false,
              BuySellState: false,
              DPSState: false,
              CapitalIncreaseState: false,
              AdvanceRightState: false,
              BrokerBenefitState: false,
              BrokerCreditState: false,
              ImportExcelState: false,
              TransferState: true,
            });
            this.transferForm.editFrom(data);
          } else {
            this.setState({ transferPopup: true, ModalShow: true }, () => {
              this.transferForm.editFrom(data);
            });
          }

          break;
        }
        case 7: {
          if (this.state.width >= 1200) {
            this.setState({
              InOutState: false,
              BuySellState: false,
              DPSState: false,
              CapitalIncreaseState: true,
              AdvanceRightState: false,
              BrokerBenefitState: false,
              BrokerCreditState: false,
              ImportExcelState: false,
              TransferState: false,
            });
            this.capitalIncreaseForm.editFrom(data);
          } else {
            this.setState(
              { capitalincreasePopup: true, ModalShow: true },
              () => {
                this.capitalIncreaseForm.editFrom(data);
              }
            );
          }

          break;
        }
        case 8: {
          if (this.state.width >= 1200) {
            this.setState({
              InOutState: false,
              BuySellState: false,
              DPSState: false,
              CapitalIncreaseState: true,
              AdvanceRightState: false,
              BrokerBenefitState: false,
              BrokerCreditState: false,
              ImportExcelState: false,
              TransferState: false,
            });
            this.capitalIncreaseForm.editFrom(data);
          } else {
            this.setState(
              { capitalincreasePopup: true, ModalShow: true },
              () => {
                this.capitalIncreaseForm.editFrom(data);
              }
            );
          }

          break;
        }
        case 9: {
          if (this.state.width >= 1200) {
            this.setState({
              InOutState: false,
              BuySellState: false,
              DPSState: false,
              CapitalIncreaseState: false,
              AdvanceRightState: true,
              BrokerBenefitState: false,
              BrokerCreditState: false,
              ImportExcelState: false,
              TransferState: false,
            });
            this.advanceRightForm.editFrom(data);
          } else {
            this.setState({ advancerightPopup: true, ModalShow: true }, () => {
              this.advanceRightForm.editFrom(data);
            });
          }

          break;
        }
        case 12: {
          if (this.state.width >= 1200) {
            this.setState({
              InOutState: false,
              BuySellState: false,
              DPSState: false,
              CapitalIncreaseState: false,
              AdvanceRightState: false,
              BrokerBenefitState: true,
              BrokerCreditState: false,
              ImportExcelState: false,
              TransferState: false,
            });
            this.BrokerBenefitForm.editFrom(data);
          } else {
            this.setState({ brokerbenefitPopup: true, ModalShow: true }, () => {
              this.BrokerBenefitForm.editFrom(data);
            });
          }

          break;
        }
        case 13: {
          if (this.state.width >= 1200) {
            this.setState({
              InOutState: false,
              BuySellState: false,
              DPSState: false,
              CapitalIncreaseState: false,
              AdvanceRightState: false,
              BrokerBenefitState: false,
              BrokerCreditState: true,
              ImportExcelState: false,
              TransferState: false,
            });
            this.BrokerCreditForm.editFrom(data);
          } else {
            this.setState({ brokercreditPopup: true, ModalShow: true }, () => {
              this.BrokerCreditForm.editFrom(data);
            });
          }

          break;
        }
        case 14: {
          if (this.state.width >= 1200) {
            this.setState({
              InOutState: false,
              BuySellState: false,
              DPSState: false,
              CapitalIncreaseState: false,
              AdvanceRightState: false,
              BrokerBenefitState: false,
              BrokerCreditState: true,
              ImportExcelState: false,
              TransferState: false,
            });
            this.BrokerCreditForm.editFrom(data);
          } else {
            this.setState({ brokercreditPopup: true, ModalShow: true }, () => {
              this.BrokerCreditForm.editFrom(data);
            });
          }

          break;
        }
        default:
          break;
      }
    } catch (error) {}
  }

  deleteTransactionRequest(data) {
    if (data.child !== undefined) {
      this.setState({ currentDeleteTransaction: data.child }, () => {
        this.setState({ deleteTransaction: true, ModalShow: true });
      });
    } else {
      this.setState({ currentDeleteTransaction: data }, () => {
        this.setState({ deleteTransaction: true, ModalShow: true });
      });
    }
  }

  deleteTransYES() {
    this.deleteTransaction(this.state.currentDeleteTransaction);
  }

  deleteTransNO() {
    this.hideModal();
  }

  deleteTransaction(data) {
    try {
      let typeId;
      let list = [];

      if (data.length > 0) {
        data.forEach(function (entry) {
          list.push(entry);
          if (entry.type_id === 6 || entry.type_id === 9) {
            typeId = entry.type_id;
          }
        });
      } else {
        typeId = data.type_id;
        list.push(data);
      }

      let body = {
        mobile: localStorage.getItem("mobile"),
        token: localStorage.getItem("token"),
        list: list,
        type: typeId,
      };
      // return
      this.setState({ deleteTransButtonDisabled: true });

      fetch("/api/deleteTransaction", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      })
        .then((res) => res.json())
        .then((resultt) => {
          // console.log(resultt);
          if (resultt.status === 200) {
            this.getUserBrokers();
            this.hideModal();
          } else {
            toast.error(resultt.message, {
              position: toast.POSITION.BOTTOM_LEFT,
              hideProgressBar: true,
              autoClose: 8000,
              toastClassName: "toast",
            });
            this.hideModal();
          }
          this.setState({ deleteTransButtonDisabled: false });
        });
    } catch (error) {
      this.setState({ deleteTransButtonDisabled: false });
      this.props.history.push("/Login");
    }
  }

  filterPortfolio(date, currentDate) {
    try {
      this.setState(
        { currentPortfolioFilter: date, currentPortfolioDate: currentDate },
        () => {
          this.getPortfolio(
            this.state.selectedPortfolioId,
            this.state.currentPotfolioType,
            false
          );
        }
      );
    } catch (error) {}
  }

  ExportExcel() {
    try {
      let data;
      let apiName;

      if (this.state.selectedPortfolioId === 0) {
        data = {
          mobile: localStorage.getItem("mobile"),
          token: localStorage.getItem("token"),
          type: this.state.currentPotfolioType,
          date: this.state.currentPortfolioFilter,
          toXls: true,
        };
        apiName = "totalPortfolio";
      } else {
        data = {
          mobile: localStorage.getItem("mobile"),
          token: localStorage.getItem("token"),
          basket_id: this.state.selectedPortfolioId,
          type: this.state.currentPotfolioType,
          date: this.state.currentPortfolioFilter,
          toXls: true,
        };
        apiName = "portfolio";
      }
      fetch("/api/" + apiName, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.body)
        .then((stream) => new Response(stream))
        .then((response) => response.blob())
        .then((blob) => URL.createObjectURL(blob))
        .then((url) => {
          const link = document.createElement("a");
          link.href = url;
          link.download =
            "Portfolio_" +
            this.state.selectedPortfolioName +
            "_" +
            this.state.currentPortfolioDate +
            ".xlsx";
          // link.download = "burcel_"+ Date.now().toString() + ".xlsx";
          document.body.appendChild(link);
          link.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );
          document.body.removeChild(link);
          this.dashboardPage.exportExcelIsDone();
        })
        .catch((err) => {
          toast.error(err.message, {
            position: toast.POSITION.BOTTOM_LEFT,
            hideProgressBar: true,
            autoClose: 8000,
            toastClassName: "toast",
          });
          this.dashboardPage.exportExcelIsDone();
        });
    } catch (error) {
      toast.error(error.message, {
        position: toast.POSITION.BOTTOM_LEFT,
        hideProgressBar: true,
        autoClose: 8000,
        toastClassName: "toast",
      });
      this.dashboardPage.exportExcelIsDone();
    }
  }

  hideFormMenu() {
    this.setState({ FormMenuVisible: false, ModalShow: false });
  }

  showFormMenu() {
    // this.setState({FormMenuVisible:true,ModalShow:true})
    this.setState({ FormMenuVisible: true });
  }

  OpenBuySellWithSymbol(symbol, symbolid) {
    if (this.state.width >= 1200) {
      this.setState({
        InOutState: false,
        BuySellState: true,
        DPSState: false,
        CapitalIncreaseState: false,
        AdvanceRightState: false,
        BrokerBenefitState: false,
        BrokerCreditState: false,
        ImportExcelState: false,
        TransferState: false,
      });
      this.buySellForm.setSymbolFromGrid(symbol, symbolid);
    } else {
      this.setState({ buysellPopup: true, ModalShow: true }, () => {
        this.buySellForm.setSymbolFromGrid(symbol, symbolid);
        if (Number(this.state.selectedPortfolioId) !== 0)
          this.buySellForm.setBasketValue(
            this.state.selectedPortfolioName,
            false
          );
        if (this.state.brokerselectedindex !== null)
          this.buySellForm.setBrokerValue(
            this.state.userBrokersData[this.state.brokerselectedindex]
              .full_name,
            false
          );
        else if (this.state.userBrokersData.length === 1)
          this.buySellForm.setBrokerValue(
            this.state.userBrokersData[0].full_name,
            true
          );
      });
    }
  }

  showTwrrMessage() {
    this.setState({ ModalShow: true, twrrMessage: true });
  }

  showMwrrMessage() {
    this.setState({ ModalShow: true, mwrrMessage: true });
  }

  render() {
    const { menuButtons } = this.state;
    const allOptions = menuButtons.map((item, i) => {
      return (
        <Link to={item.url} key={i}>
          <div ref={(scope) => (this.sidebarItems[i] = scope)}>
            <SideButton
              showTitle={false}
              imgWidth="auto"
              imgHeight="25px"
              borderWidth="0px"
              borderRadius="0px"
              icon1={item.icon1}
              icon2={item.icon2}
              text={item.title}
              selected={this.state.sideMenuSelectedIndex === i}
              index={i}
              handler={this.onSideMenuSelect.bind(this)}
            />
          </div>
        </Link>
      );
    });

    if (this.state.width < 768) {
      if (this.state.sidebarCreated) {
      }
    } else {
      if (this.state.sidebarCreated) {
      }
    }

    if (this.state.serverResponse) {
      if (localStorage.getItem("token") === this.state.token) {
        return (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "100vh",
              maxHeight: "100vh",
              width: "100vw",
              maxWidth: "100vw",
              overflow: "hidden",
            }}
          >
            <Menu
              isOpen={this.state.FormMenuVisible}
              onClose={() => {
                this.setState({ FormMenuVisible: false });
              }}
              customCrossIcon={false}
              customBurgerIcon={false}
              right
              style={{ overflow: "hidden" }}
            >
              <FormMenuItem
                style={{
                  minHeight: "30px",
                  maxHeight: "60px",
                  height: "8vh",
                  backgroundColor: "red",
                }}
                image={null}
                title=""
                clickHandle={() => this.setState({ FormMenuVisible: false })}
              />
              <FormMenuItem
                image={inouticon}
                title="واریز و برداشت"
                clickHandle={() =>
                  this.setState(
                    {
                      ModalShow: true,
                      FormMenuVisible: false,
                      inoutPopup: true,
                    },
                    () => {
                      if (Number(this.state.selectedPortfolioId) !== 0)
                        this.inOutForm.setBasketValue(
                          this.state.selectedPortfolioName,
                          false
                        );
                      if (this.state.brokerselectedindex !== null)
                        this.inOutForm.setBrokerValue(
                          this.state.userBrokersData[
                            this.state.brokerselectedindex
                          ].full_name,
                          false
                        );
                      else if (this.state.userBrokersData.length === 1)
                        this.inOutForm.setBrokerValue(
                          this.state.userBrokersData[0].full_name,
                          true
                        );
                    }
                  )
                }
              />
              <FormMenuItem
                image={buysellicon}
                title="خرید و فروش"
                clickHandle={() =>
                  this.setState(
                    {
                      ModalShow: true,
                      FormMenuVisible: false,
                      buysellPopup: true,
                    },
                    () => {
                      if (Number(this.state.selectedPortfolioId) !== 0)
                        this.buySellForm.setBasketValue(
                          this.state.selectedPortfolioName,
                          false
                        );
                      if (this.state.brokerselectedindex !== null)
                        this.buySellForm.setBrokerValue(
                          this.state.userBrokersData[
                            this.state.brokerselectedindex
                          ].full_name,
                          false
                        );
                      else if (this.state.userBrokersData.length === 1)
                        this.buySellForm.setBrokerValue(
                          this.state.userBrokersData[0].full_name,
                          true
                        );
                    }
                  )
                }
              />
              <FormMenuItem
                image={dpsicon}
                title="سود سهام تقسیم شده (DPS)"
                clickHandle={() =>
                  this.setState(
                    { ModalShow: true, FormMenuVisible: false, dpsPopup: true },
                    () => {
                      if (Number(this.state.selectedPortfolioId) !== 0)
                        this.DPSForm.setBasketValue(
                          this.state.selectedPortfolioName,
                          false
                        );
                    }
                  )
                }
              />
              <FormMenuItem
                image={stockprofiticon}
                title="سود کارگزاری"
                clickHandle={() =>
                  this.setState(
                    {
                      ModalShow: true,
                      FormMenuVisible: false,
                      brokerbenefitPopup: true,
                    },
                    () => {
                      if (Number(this.state.selectedPortfolioId) !== 0)
                        this.BrokerBenefitForm.setBasketValue(
                          this.state.selectedPortfolioName,
                          false
                        );
                      if (this.state.brokerselectedindex !== null)
                        this.BrokerBenefitForm.setBrokerValue(
                          this.state.userBrokersData[
                            this.state.brokerselectedindex
                          ].full_name,
                          false
                        );
                      else if (this.state.userBrokersData.length === 1)
                        this.BrokerBenefitForm.setBrokerValue(
                          this.state.userBrokersData[0].full_name,
                          true
                        );
                    }
                  )
                }
              />
              <FormMenuItem
                image={profitcredit}
                title="اعتبار کارگزاری"
                clickHandle={() =>
                  this.setState(
                    {
                      ModalShow: true,
                      FormMenuVisible: false,
                      brokercreditPopup: true,
                    },
                    () => {
                      if (Number(this.state.selectedPortfolioId) !== 0)
                        this.BrokerCreditForm.setBasketValue(
                          this.state.selectedPortfolioName,
                          false
                        );
                      if (this.state.brokerselectedindex !== null)
                        this.BrokerCreditForm.setBrokerValue(
                          this.state.userBrokersData[
                            this.state.brokerselectedindex
                          ].full_name,
                          false
                        );
                      else if (this.state.userBrokersData.length === 1)
                        this.BrokerCreditForm.setBrokerValue(
                          this.state.userBrokersData[0].full_name,
                          true
                        );
                    }
                  )
                }
              />
              <FormMenuItem
                image={increaseicon}
                title="افزایش سرمایه"
                clickHandle={() =>
                  this.setState(
                    {
                      ModalShow: true,
                      FormMenuVisible: false,
                      capitalincreasePopup: true,
                    },
                    () => {
                      if (Number(this.state.selectedPortfolioId) !== 0)
                        this.capitalIncreaseForm.setBasketValue(
                          this.state.selectedPortfolioName,
                          false
                        );
                      if (this.state.brokerselectedindex !== null)
                        this.capitalIncreaseForm.setBrokerValue(
                          this.state.userBrokersData[
                            this.state.brokerselectedindex
                          ].full_name,
                          false
                        );
                      else if (this.state.userBrokersData.length === 1)
                        this.capitalIncreaseForm.setBrokerValue(
                          this.state.userBrokersData[0].full_name,
                          true
                        );
                    }
                  )
                }
              />
              <FormMenuItem
                image={righticon}
                title="تبدیل حق تقدم به سهم"
                clickHandle={() =>
                  this.setState(
                    {
                      ModalShow: true,
                      FormMenuVisible: false,
                      advancerightPopup: true,
                    },
                    () => {
                      if (Number(this.state.selectedPortfolioId) !== 0)
                        this.advanceRightForm.setBasketValue(
                          this.state.selectedPortfolioName,
                          false
                        );
                      if (this.state.brokerselectedindex !== null)
                        this.advanceRightForm.setBrokerValue(
                          this.state.userBrokersData[
                            this.state.brokerselectedindex
                          ].full_name,
                          false
                        );
                      else if (this.state.userBrokersData.length === 1)
                        this.advanceRightForm.setBrokerValue(
                          this.state.userBrokersData[0].full_name,
                          true
                        );
                    }
                  )
                }
              />
              <FormMenuItem
                image={transfericon}
                title="انتقال سهم بین سبدها"
                clickHandle={() =>
                  this.setState({
                    ModalShow: true,
                    FormMenuVisible: false,
                    transferPopup: true,
                  })
                }
              />
              <FormMenuItem
                image={excelicon}
                title="ورود اطلاعات با اکسل"
                clickHandle={() =>
                  this.setState(
                    {
                      ModalShow: true,
                      FormMenuVisible: false,
                      importexcelPopup: true,
                    },
                    () => {
                      if (Number(this.state.selectedPortfolioId) !== 0)
                        this.ImportExcelForm.setBasketValue(
                          this.state.selectedPortfolioName,
                          false
                        );
                      if (this.state.brokerselectedindex !== null)
                        this.ImportExcelForm.setBrokerValue(
                          this.state.userBrokersData[
                            this.state.brokerselectedindex
                          ].full_name,
                          false
                        );
                      else if (this.state.userBrokersData.length === 1)
                        this.ImportExcelForm.setBrokerValue(
                          this.state.userBrokersData[0].full_name,
                          true
                        );
                    }
                  )
                }
              />
            </Menu>

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                height: "100vh",
                maxHeight: "100vh",
                overflow: "hidden",
              }}
              className={this.state.ModalShow ? "filterBackground" : null}
            >
              <div id="dashboardMain" className="dashboardMain">
                {this.state.width < 1200 && (
                  <div className="dashboardHeaderParent">
                    <div
                      className={
                        this.state.ModalShow
                          ? "dashboardHeader filterBackground"
                          : "dashboardHeader"
                      }
                    >
                      <SideButton
                        small
                        noFlex
                        showTitle={false}
                        imgWidth="auto"
                        imgHeight="25px"
                        borderWidth="0px"
                        borderRadius="0px"
                        icon1={menu}
                        icon2={menu}
                        selected={false}
                        handler={this.showFormMenu.bind(this)}
                      />
                      <div style={{ flex: "1" }}>{this.state.userFullName}</div>
                      <SideButton
                        small
                        noFlex
                        showTitle={false}
                        imgWidth="25px"
                        imgHeight="25px"
                        borderWidth="1px"
                        borderRadius="50%"
                        icon1={this.state.profilePicture}
                        icon2={this.state.profilePicture}
                        selected={false}
                        handler={this.onProfileClick.bind(this)}
                      />
                    </div>
                  </div>
                )}

                {this.state.width < 1200 && (
                  <div className="dashboardHeaderFill"></div>
                )}

                {this.state.width >= 1200 && (
                  <div className="dashboardsidebar">
                    <div className="profilestyle">
                      <SideButton
                        notSelectable={true}
                        showTitle={false}
                        imgWidth="30px"
                        imgHeight="auto"
                        borderWidth="0px"
                        borderRadius="0px"
                        icon1={burcelLogoGraphic}
                        icon2={burcelLogoGraphic}
                        selected={false}
                        handler={this.onSiteClick.bind(this)}
                      />
                      <SideButton
                        showTitle={false}
                        imgWidth="25px"
                        imgHeight="25px"
                        borderWidth="1px"
                        borderRadius="50%"
                        icon1={this.state.profilePicture}
                        icon2={this.state.profilePicture}
                        text="پروفایل"
                        selected={false}
                        handler={this.onProfileClick.bind(this)}
                      />
                    </div>

                    <div
                      style={{
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        display: "flex",
                      }}
                    >
                      <div
                        style={{ display: "flex", flexDirection: "column" }}
                        ref={(scope) => (this.targettt = scope)}
                      >
                        {allOptions}
                      </div>
                    </div>
                    <div className="profilestyle">
                      <SideButton
                        notSelectable={true}
                        showTitle={false}
                        imgWidth="0"
                        imgHeight="0"
                        borderWidth="0px"
                        borderRadius="0px"
                        icon1={null}
                        icon2={null}
                        text=""
                        selected={false}
                      />
                      <SideButton
                        showTitle={false}
                        imgWidth="auto"
                        imgHeight="25px"
                        borderWidth="0px"
                        borderRadius="0px"
                        icon1={exit}
                        icon2={exit}
                        text="خروج"
                        selected={false}
                        handler={this.onLogoutClick.bind(this)}
                      />
                    </div>
                  </div>
                )}

                {this.state.width >= 1200 && (
                  <div
                    className="slidetoggleConnection"
                    style={{ top: this.state.top, left: this.state.left }}
                  >
                    <div className="slidetoggleConnectionInner" />
                  </div>
                )}

                <div id="dashboardMiddle" className="dashboardMiddle">
                  <div
                    ref={(scope) => (this.dashboardContent = scope)}
                    className="dashboardContent"
                  >
                    <div className="dashboardd" ref={this.dashboardd}>
                      <div className="brokercont" ref={this.brokercont}>
                        <ScrollContainer
                          activationDistance={20}
                          className="dashBrokersContainer"
                        >
                          {this.state.userBrokersData.map((item, i) =>
                            item.status === 2 ? (
                              <Broker
                                key={item.id}
                                name={item.broker_name}
                                price={item.balance}
                                logo={"/api/public/" + item.logo}
                                selected={
                                  this.state.brokerselectedindex === i
                                    ? true
                                    : false
                                }
                                lable={item.lable}
                                isLast={
                                  this.state.userBrokersData.length - 1 === i
                                    ? true
                                    : false
                                }
                                archiveBroker={this.archiveBroker.bind(
                                  this,
                                  i,
                                  item.id,
                                  item.broker_name
                                )}
                                editBroker={this.editBroker.bind(
                                  this,
                                  i,
                                  item.id
                                )}
                                clicked={this.brokerClick.bind(
                                  this,
                                  i,
                                  item.id,
                                  item.broker_name,
                                  item.full_name
                                )}
                              />
                            ) : null
                          )}
                        </ScrollContainer>

                        <div style={{ paddingRight: "5px" }}>
                          <Button
                            variant="light"
                            onClick={this.addBrokerButton.bind(this)}
                            className="brokerPlusButton"
                          >
                            <Image style={{ height: "20px" }} src={edit} />
                          </Button>
                        </div>
                      </div>

                      <div className="tabsComponent">
                        <div
                          className="titlesContainer"
                          ref={this.tabsTitlesContainer}
                        >
                          <ScrollContainer
                            activationDistance={20}
                            className="tabsTitlesContainer"
                          >
                            {this.state.userBasketsData.map((item, i) =>
                              item.status === 2 ? (
                                <div
                                  key={i}
                                  className={
                                    this.state.tabselectedindex === i && i === 0
                                      ? "tabsTitlesContainerAllFirst"
                                      : this.state.tabselectedindex === i &&
                                        i ===
                                          this.state.userBasketsData.length - 1
                                      ? "tabsTitlesContainerAllLast"
                                      : this.state.tabselectedindex === i
                                      ? "tabsTitlesContainerAllSelected"
                                      : "tabsTitlesContainerAll"
                                  }
                                  style={
                                    i === 0
                                      ? { margin: "0px" }
                                      : { marginRight: "5px" }
                                  }
                                >
                                  <div
                                    className={
                                      this.state.tabselectedindex === i &&
                                      i === 0
                                        ? "tabsItemHighlightContainerFirst"
                                        : this.state.tabselectedindex === i &&
                                          i ===
                                            this.state.userBasketsData.length -
                                              1
                                        ? "tabsItemHighlightContainerLast"
                                        : this.state.tabselectedindex === i
                                        ? "tabsItemHighlightContainerSelected"
                                        : "tabsItemHighlightContainer"
                                    }
                                  >
                                    <div
                                      className={
                                        this.state.tabselectedindex === i
                                          ? "tabsItemHighlightSelected"
                                          : "tabsItemHighlight"
                                      }
                                      onClick={this.basketItemClicked.bind(
                                        this,
                                        i,
                                        item.id,
                                        item.lable,
                                        item.percent
                                      )}
                                    >
                                      <div className="tabsItem">
                                        <div
                                          style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                          }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              flexDirection: "row-reverse",
                                            }}
                                          >
                                            <div
                                              className="basketTitle"
                                              title={item.lable}
                                            >
                                              {item.lable}
                                            </div>
                                            {item.percent !== null &&
                                              item.percent !== "" &&
                                              item.percent !== undefined && (
                                                <div
                                                  style={{
                                                    fontSize: "10px",
                                                    color: "#97AAAB",
                                                    marginRight: "4px",
                                                  }}
                                                >
                                                  ({item.percent}%)
                                                </div>
                                              )}
                                          </div>
                                          {item.balance !== null && (
                                            <div
                                              className="basketBalance"
                                              style={{
                                                color:
                                                  item.balance < 0
                                                    ? "var(--red1)"
                                                    : "#97AAAB",
                                              }}
                                            >
                                              <NumberFormat
                                                allowNegative={true}
                                                value={item.balance}
                                                displayType={"text"}
                                                thousandSeparator={true}
                                              />
                                            </div>
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ) : null
                            )}
                          </ScrollContainer>
                          <div style={{ paddingRight: "5px" }}>
                            <Button
                              variant="light"
                              onClick={this.editBasketButton.bind(this)}
                              className="basketPlusButton"
                            >
                              <Image style={{ height: "20px" }} src={edit} />
                            </Button>
                          </div>
                        </div>

                        <Route
                          exact
                          path="/"
                          render={(props) => (
                            <DashboardContent
                              {...props}
                              ref={(scope1) => (this.dashboardPage = scope1)}
                              onChangeType={this.getPortfolio.bind(this)}
                              portfolioID={this.state.selectedPortfolioId}
                              portfolioData={this.state.selectedPortfolio}
                              industryData={this.state.selectedBasketChart1}
                              industryBasedOnData={this.state.chart1BasedOn}
                              portfolioBasedOnData={this.state.chart2BasedOn}
                              chart3Data={this.state.selectedBasketChart3}
                              accordionOpen={this.accordionOpen.bind(this)}
                              tabselectedindex={this.state.tabselectedindex}
                              gridLocaleText={this.state.gridLocaleText}
                              pageIsopen={this.dashboardPageIsOpen.bind(this)}
                              filterPortfolio={this.filterPortfolio.bind(this)}
                              hasTransaction={
                                this.state.dashboardHasTransaction
                              }
                              ExportExcel={this.ExportExcel.bind(this)}
                              pageWidth={this.state.width}
                              OpenBuySellWithSymbol={this.OpenBuySellWithSymbol.bind(
                                this
                              )}
                            />
                          )}
                        />

                        <Route
                          path="/Turnover"
                          render={(props) => (
                            <Turnover
                              {...props}
                              ref={(scope) => (this.turnoverPage = scope)}
                              pageIsopen={this.turnoverPageIsOpen.bind(this)}
                              turnOverData={this.state.turnOverData}
                              selectedBasket={this.state.selectedPortfolioId}
                              selectedBroker={this.state.selectedBrokerId}
                              tabselectedindex={this.state.tabselectedindex}
                              gridLocaleText={this.state.gridLocaleText}
                              accordionOpen={this.accordionOpen.bind(this)}
                              edit={this.editTransaction.bind(this)}
                              selectedPortfolioName={
                                this.state.selectedPortfolioName
                              }
                              pageWidth={this.state.width}
                              deleteTransactionRequest={this.deleteTransactionRequest.bind(
                                this
                              )}
                            />
                          )}
                        />

                        <Route
                          path="/Chart"
                          render={(props) => (
                            <Chart
                              {...props}
                              ref={(scope) => (this.chartPage = scope)}
                              pageIsopen={this.chartPageIsOpen.bind(this)}
                              tabselectedindex={this.state.tabselectedindex}
                              accordionOpen={this.accordionOpen.bind(this)}
                              portfolioID={this.state.selectedPortfolioId}
                              pageWidth={this.state.width}
                              selectedPortfolioName={
                                this.state.selectedPortfolioName
                              }
                            />
                          )}
                        />

                        <Route
                          path="/Profit"
                          render={(props) => (
                            <Profit
                              {...props}
                              ref={(scope) => (this.profitPage = scope)}
                              pageIsopen={this.profitPageIsOpen.bind(this)}
                              tabselectedindex={this.state.tabselectedindex}
                              accordionOpen={this.accordionOpen.bind(this)}
                              portfolioID={this.state.selectedPortfolioId}
                              selectedPortfolioPercent={
                                this.state.selectedPortfolioPercent
                              }
                              userBasketsData={this.state.userBasketsDataMain}
                              twrrMessage={this.showTwrrMessage.bind(this)}
                              pageWidth={this.state.width}
                              mwrrMessage={this.showMwrrMessage.bind(this)}
                            />
                          )}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {this.state.width < 1200 && (
                  <div className="dashboardsidebarsmall">
                    {this.state.menuButtons.map((item, i) => {
                      return (
                        <div style={{ height: "100%", flex: "1" }} key={i}>
                          <Link to={item.url}>
                            <SideButton
                              small
                              showTitle={false}
                              imgWidth="auto"
                              imgHeight="22px"
                              borderWidth="0px"
                              borderRadius="0px"
                              icon1={item.icon2}
                              icon2={item.icon2}
                              text={item.title}
                              selected={this.state.sideMenuSelectedIndex === i}
                              index={i}
                              handler={this.onSideMenuSelect.bind(this)}
                            />
                          </Link>
                        </div>
                      );
                    })}
                    <SideButton
                      small
                      showTitle={false}
                      imgWidth="auto"
                      imgHeight="25px"
                      borderWidth="0px"
                      borderRadius="0px"
                      icon1={exit2}
                      icon2={exit2}
                      text="خروج"
                      selected={false}
                      handler={this.onLogoutClick.bind(this)}
                    />
                  </div>
                )}

                {this.state.width >= 1200 && (
                  <div className="dashboardsidebarLeftContainer">
                    <div className="dashboardsidebarLeft">
                      <Accordion className="accStyle">
                        <Card>
                          <Accordion.Toggle
                            className="accordionToggle"
                            as={Card.Header}
                            eventKey={1}
                            onClick={this.InOutClicked.bind(this)}
                          >
                            <div className="accTitleStyle">
                              <img
                                src={inouticon}
                                className="accordionToggleImage"
                                alt=""
                              />
                              واریز و برداشت
                            </div>
                          </Accordion.Toggle>
                          <Accordion.Collapse
                            eventKey={1}
                            in={this.state.InOutState}
                          >
                            <Card.Body>
                              <InOut
                                ref={(scope) => (this.inOutForm = scope)}
                                selectedPortfolioId={
                                  this.state.selectedPortfolioId
                                }
                                selectedBrokerId={this.state.selectedBrokerId}
                                onRefresh={this.onPageDataRefresh.bind(this)}
                                userBrokersData={this.state.userBrokersData}
                                userBasketsData={this.state.userBasketsDataMain}
                              />
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                        <Card>
                          <Accordion.Toggle
                            className="accordionToggle"
                            as={Card.Header}
                            eventKey={0}
                            onClick={this.BuySellClicked.bind(this)}
                          >
                            <div className="accTitleStyle">
                              <img
                                src={buysellicon}
                                className="accordionToggleImage"
                                alt=""
                              />
                              خرید و فروش
                            </div>
                          </Accordion.Toggle>
                          <Accordion.Collapse
                            eventKey={0}
                            in={this.state.BuySellState}
                          >
                            <Card.Body>
                              <BuySell
                                selectedPortfolioId={
                                  this.state.selectedPortfolioId
                                }
                                selectedBrokerId={this.state.selectedBrokerId}
                                Rendered={this.state.serverResponse}
                                ref={(scope) => (this.buySellForm = scope)}
                                onRefresh={this.onPageDataRefresh.bind(this)}
                                userBrokersData={this.state.userBrokersData}
                                userBasketsData={this.state.userBasketsDataMain}
                                symbolsData={this.state.symbolsData}
                              />
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                        <Card>
                          <Accordion.Toggle
                            className="accordionToggle"
                            as={Card.Header}
                            eventKey={2}
                            onClick={this.DPSClicked.bind(this)}
                          >
                            <div className="accTitleStyle">
                              <img
                                src={dpsicon}
                                className="accordionToggleImage"
                                alt=""
                              />
                              سود سهام تقسیم شده (DPS)
                            </div>
                          </Accordion.Toggle>
                          <Accordion.Collapse
                            eventKey={2}
                            in={this.state.DPSState}
                          >
                            <Card.Body>
                              <DPS
                                submitDPSDevisionSuccess={this.submitDPSDevisionSuccess.bind(
                                  this
                                )}
                                showSuggestion={this.showDPSSuggestion.bind(
                                  this
                                )}
                                selectedPortfolioId={
                                  this.state.selectedPortfolioId
                                }
                                selectedBrokerId={this.state.selectedBrokerId}
                                ref={(scope) => (this.DPSForm = scope)}
                                onRefresh={this.onPageDataRefresh.bind(this)}
                                userBasketsData={this.state.userBasketsDataMain}
                                symbolsData={this.state.symbolsData}
                              />
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                        <Card>
                          <Accordion.Toggle
                            className="accordionToggle"
                            as={Card.Header}
                            eventKey={6}
                            onClick={this.BrokerBenefitClicked.bind(this)}
                          >
                            <div className="accTitleStyle">
                              <img
                                src={stockprofiticon}
                                className="accordionToggleImage"
                                alt=""
                              />
                              سود کارگزاری
                            </div>
                          </Accordion.Toggle>
                          <Accordion.Collapse
                            eventKey={6}
                            in={this.state.BrokerBenefitState}
                          >
                            <Card.Body>
                              <BrokerBenefit
                                ref={(scope) =>
                                  (this.BrokerBenefitForm = scope)
                                }
                                selectedPortfolioId={
                                  this.state.selectedPortfolioId
                                }
                                selectedBrokerId={this.state.selectedBrokerId}
                                onRefresh={this.onPageDataRefresh.bind(this)}
                                userBrokersData={this.state.userBrokersData}
                                userBasketsData={this.state.userBasketsDataMain}
                              />
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                        <Card>
                          <Accordion.Toggle
                            className="accordionToggle"
                            as={Card.Header}
                            eventKey={7}
                            onClick={this.BrokerCreditClicked.bind(this)}
                          >
                            <div className="accTitleStyle">
                              <img
                                src={profitcredit}
                                className="accordionToggleImage"
                                alt=""
                              />
                              اعتبار کارگزاری
                            </div>
                          </Accordion.Toggle>
                          <Accordion.Collapse
                            eventKey={7}
                            in={this.state.BrokerCreditState}
                          >
                            <Card.Body>
                              <BrokerCredit
                                ref={(scope) => (this.BrokerCreditForm = scope)}
                                selectedPortfolioId={
                                  this.state.selectedPortfolioId
                                }
                                selectedBrokerId={this.state.selectedBrokerId}
                                onRefresh={this.onPageDataRefresh.bind(this)}
                                userBrokersData={this.state.userBrokersData}
                                userBasketsData={this.state.userBasketsDataMain}
                              />
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                        <Card>
                          <Accordion.Toggle
                            className="accordionToggle"
                            as={Card.Header}
                            eventKey={3}
                            onClick={this.CapitalIncreaseClicked.bind(this)}
                          >
                            <div className="accTitleStyle">
                              <img
                                src={increaseicon}
                                className="accordionToggleImage"
                                alt=""
                              />
                              افزایش سرمایه
                            </div>
                          </Accordion.Toggle>
                          <Accordion.Collapse
                            eventKey={3}
                            in={this.state.CapitalIncreaseState}
                          >
                            <Card.Body>
                              <CapitalIncrease
                                submitIncreaseDevisionSuccess={this.submitIncreaseDevisionSuccess.bind(
                                  this
                                )}
                                showSuggestion={this.showIncreaseSuggestion.bind(
                                  this
                                )}
                                selectedBrokerId={this.state.selectedBrokerId}
                                selectedPortfolioId={
                                  this.state.selectedPortfolioId
                                }
                                ref={(scope) =>
                                  (this.capitalIncreaseForm = scope)
                                }
                                onRefresh={this.onPageDataRefresh.bind(this)}
                                userBrokersData={this.state.userBrokersData}
                                userBasketsData={this.state.userBasketsDataMain}
                                symbolsData={this.state.symbolsData}
                              />
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                        <Card>
                          <Accordion.Toggle
                            className="accordionToggle"
                            as={Card.Header}
                            eventKey={4}
                            onClick={this.AdvanceRightClicked.bind(this)}
                          >
                            <div className="accTitleStyle">
                              <img
                                src={righticon}
                                className="accordionToggleImage"
                                alt=""
                              />
                              تبدیل حق تقدم به سهم
                            </div>
                          </Accordion.Toggle>
                          <Accordion.Collapse
                            eventKey={4}
                            in={this.state.AdvanceRightState}
                          >
                            <Card.Body>
                              <AdvanceRight
                                selectedPortfolioId={
                                  this.state.selectedPortfolioId
                                }
                                selectedBrokerId={this.state.selectedBrokerId}
                                ref={(scope) => (this.advanceRightForm = scope)}
                                onRefresh={this.onPageDataRefresh.bind(this)}
                                userBrokersData={this.state.userBrokersData}
                                userBasketsData={this.state.userBasketsDataMain}
                                symbolsData={this.state.symbolsData}
                              />
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>

                        <Card>
                          <Accordion.Toggle
                            className={
                              this.state.userBasketsData.length > 1
                                ? "accordionToggle"
                                : "accordionToggleDisabled"
                            }
                            as={Card.Header}
                            eventKey={5}
                            onClick={this.TransferClicked.bind(this)}
                          >
                            <div>
                              <img
                                src={transfericon}
                                className="accordionToggleImage"
                                alt=""
                              />
                              انتقال سهم بین سبدها
                            </div>
                          </Accordion.Toggle>
                          <Accordion.Collapse
                            eventKey={5}
                            in={this.state.TransferState}
                          >
                            <Card.Body>
                              <Transfer
                                ref={(scope) => (this.transferForm = scope)}
                                onRefresh={this.onPageDataRefresh.bind(this)}
                                userBasketsData={this.state.userBasketsDataMain}
                                selectedBrokerId={this.state.selectedBrokerId}
                                userBrokersData={this.state.userBrokersData}
                                symbolsData={this.state.symbolsData}
                              />
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                        <Card>
                          <Accordion.Toggle
                            className="accordionToggle"
                            as={Card.Header}
                            eventKey={7}
                            onClick={this.ImportExcelClicked.bind(this)}
                          >
                            <div className="accTitleStyle">
                              <img
                                src={excelicon}
                                className="accordionToggleImage"
                                alt=""
                              />
                              ورود اطلاعات با اکسل
                            </div>
                          </Accordion.Toggle>
                          <Accordion.Collapse
                            eventKey={7}
                            in={this.state.ImportExcelState}
                          >
                            <Card.Body>
                              <ImportExcel
                                ref={(scope) => (this.ImportExcelForm = scope)}
                                selectedPortfolioId={
                                  this.state.selectedPortfolioId
                                }
                                selectedBrokerId={this.state.selectedBrokerId}
                                onRefresh={this.onPageDataRefresh.bind(this)}
                                userBrokersData={this.state.userBrokersData}
                                userBasketsData={this.state.userBasketsDataMain}
                              />
                            </Card.Body>
                          </Accordion.Collapse>
                        </Card>
                      </Accordion>
                    </div>
                  </div>
                )}

                <Modal
                  show={this.state.ModalShow}
                  animation={false}
                  onHide={this.hideModal.bind(this)}
                  centered
                  // backdrop={this.state.modalBackDrop}
                >
                  {this.state.editProfile && (
                    <div className="popup-items">
                      <Profile
                        inModal={true}
                        hideModal={this.hideModal.bind(this)}
                        profileSave={this.profileSave.bind(this)}
                      />
                    </div>
                  )}

                  {this.state.archiveBroker && (
                    <div className="popup">
                      آیا مطمئن به آرشیو کارگزاری "
                      {this.state.archiveBrokerName}" هستید؟
                      <div className="popupButtons">
                        <Button
                          variant="primary"
                          style={{ fontSize: "14px", margin: "5px" }}
                          onClick={this.archiveBrokerYES.bind(this)}
                        >
                          بله
                        </Button>
                        <Button
                          variant="danger"
                          style={{ fontSize: "14px", margin: "5px" }}
                          onClick={this.archiveBrokerNO.bind(this)}
                        >
                          خیر
                        </Button>
                      </div>
                    </div>
                  )}

                  {this.state.editBroker && (
                    <div className="popup-items">
                      <BrokersContent
                        inModal={true}
                        hideModal={this.hideModal.bind(this)}
                      />
                    </div>
                  )}

                  {this.state.editBasket && (
                    <div className="popup-items">
                      <BasketsContent
                        inModal={true}
                        hideModal={this.hideModal.bind(this)}
                        shareBasketItem={this.shareBasketItem.bind(this)}
                      />
                    </div>
                  )}

                  {this.state.shareBaskett && (
                    <div className="popup">
                      <div
                        style={{
                          width: "100%",
                          textAlign: "right",
                          marginBottom: "7px",
                        }}
                      >
                        لطفاً شماره تلفن همراه شخصی که میخواهید این سبد را با او
                        به اشتراک بگذارید را وارد کنید
                      </div>
                      <Form.Control
                        type="text"
                        ref={(scope) => {
                          this.shareBasketText = scope;
                        }}
                        enableRtl={true}
                        style={{ textAlign: "right", fontSize: "14px" }}
                        placeholder="شماره تلفن همراه"
                      />
                      <div className="popupButtons">
                        <Button
                          variant="primary"
                          style={{ fontSize: "14px", margin: "5px" }}
                          onClick={this.shareBasketYES.bind(this)}
                        >
                          اشتراک گذاری
                        </Button>
                        <Button
                          variant="danger"
                          style={{ fontSize: "14px", margin: "5px" }}
                          onClick={this.shareBasketNO.bind(this)}
                        >
                          انصراف
                        </Button>
                      </div>
                    </div>
                  )}

                  {this.state.archiveBasket && (
                    <div className="popup">
                      آیا مطمئن به آرشیو سبد "{this.state.archiveBasketName}"
                      هستید؟
                      <div className="popupButtons">
                        <Button
                          variant="primary"
                          style={{ fontSize: "14px", margin: "5px" }}
                          onClick={this.archiveBasketYES.bind(this)}
                        >
                          بله
                        </Button>
                        <Button
                          variant="danger"
                          style={{ fontSize: "14px", margin: "5px" }}
                          onClick={this.archiveBasketNO.bind(this)}
                        >
                          خیر
                        </Button>
                      </div>
                    </div>
                  )}

                  {this.state.deleteTransaction && (
                    <div className="popup">
                      آیا مطمئن به حذف این سند هستید؟
                      <div className="popupButtons">
                        <Button
                          variant="primary"
                          style={{ fontSize: "14px", margin: "5px" }}
                          onClick={this.deleteTransYES.bind(this)}
                          disabled={this.state.deleteTransButtonDisabled}
                        >
                          {this.state.deleteTransButtonDisabled && (
                            <Spinner
                              className="spinnerStyle"
                              animation="border"
                            />
                          )}
                          {!this.state.deleteTransButtonDisabled && (
                            <div>بله</div>
                          )}
                        </Button>
                        {/* <Button variant="primary" style={{fontSize:'14px',margin:'5px'}} onClick={this.deleteTransYES.bind(this)}>بله</Button> */}
                        <Button
                          variant="danger"
                          style={{ fontSize: "14px", margin: "5px" }}
                          onClick={this.deleteTransNO.bind(this)}
                        >
                          خیر
                        </Button>
                      </div>
                    </div>
                  )}

                  {this.state.dpsSuggestion && (
                    <div className="popup">
                      <div style={{ marginBottom: "15px" }}>
                        در صورت نیاز تعداد سهم هر سبد را مشخص کنید و دکمه تایید
                        را بزنید
                      </div>

                      <div className="suggestionsContainer">
                        {this.state.dpsSuggestionResult.length > 0 &&
                          this.state.dpsSuggestionResult.map((item) => (
                            <BaksetItem
                              type="dps"
                              dpsQuantityChange={this.dpsQuantityChange.bind(
                                this,
                                item.id
                              )}
                              key={item.id}
                              description={item.quantity}
                              desHolder="تعداد سهم"
                              itemId={item.id}
                              name={item.title}
                              price={item.price}
                            />
                          ))}
                      </div>
                      <div className="popupButtons">
                        <Button
                          variant="secondary"
                          style={{
                            fontSize: "14px",
                            margin: "5px",
                            minWidth: "130px",
                          }}
                          disabled={this.state.dpsButtonDisabled}
                          onClick={this.submitDPSDevision.bind(this)}
                        >
                          {this.state.dpsButtonDisabled && (
                            <Spinner
                              className="spinnerStyle"
                              animation="border"
                            />
                          )}
                          {!this.state.dpsButtonDisabled && (
                            <div>تایید و ثبت نهایی</div>
                          )}
                        </Button>
                        {/* <Button variant="primary" style={{fontSize:'14px',margin:'5px'}} onClick={this.submitDPSDevision.bind(this)}>تایید</Button> */}
                        <Button
                          variant="danger"
                          style={{
                            fontSize: "14px",
                            margin: "5px",
                            minWidth: "130px",
                          }}
                          onClick={this.hideModal.bind(this)}
                        >
                          انصراف
                        </Button>
                      </div>
                      {this.state.dpsActionError !== "" && (
                        <div className="errorMessageContainer">
                          <div>{this.state.dpsActionError}</div>
                        </div>
                      )}
                    </div>
                  )}

                  {this.state.increaseSuggestion && (
                    <div className="popup">
                      <div style={{ marginBottom: "15px" }}>
                        در صورت نیاز، تعداد سهم تعلق یافته به هر سبد را مشخص
                        کنید و دکمه تایید را بزنید
                      </div>

                      <div className="suggestionsContainer">
                        {this.state.increaseSuggestionResult.length > 0 &&
                          this.state.increaseSuggestionResult.map((item) => (
                            <BaksetItem
                              type="increase"
                              increaseBrokerChange={this.increaseBrokerChange.bind(
                                this,
                                item.id
                              )}
                              userBrokersData={this.state.userBrokersData}
                              dpsQuantityChange={this.increaseQuantityChange.bind(
                                this,
                                item.id
                              )}
                              key={item.id}
                              description={item.suggest}
                              desHolder="تعداد سهم"
                              itemId={item.id}
                              name={item.title}
                            />
                          ))}
                      </div>
                      <div className="popupButtons">
                        <Button
                          variant="secondary"
                          style={{
                            fontSize: "14px",
                            margin: "5px",
                            minWidth: "130px",
                          }}
                          disabled={this.state.increaseButtonDisabled}
                          onClick={this.submitIncreaseDevision.bind(this)}
                        >
                          {this.state.increaseButtonDisabled && (
                            <Spinner
                              className="spinnerStyle"
                              animation="border"
                            />
                          )}
                          {!this.state.increaseButtonDisabled && (
                            <div>تایید و ثبت نهایی</div>
                          )}
                        </Button>
                        {/* <Button variant="primary" style={{fontSize:'14px',margin:'5px'}} onClick={this.submitIncreaseDevision.bind(this)}>تایید</Button> */}
                        <Button
                          variant="danger"
                          style={{
                            fontSize: "14px",
                            margin: "5px",
                            minWidth: "130px",
                          }}
                          onClick={this.hideModal.bind(this)}
                        >
                          انصراف
                        </Button>
                      </div>
                      {this.state.increaseActionError !== "" && (
                        <div className="errorMessageContainer">
                          <div>{this.state.increaseActionError}</div>
                        </div>
                      )}
                    </div>
                  )}

                  {this.state.inoutPopup && (
                    <div className="formsPopup">
                      <InOut
                        isPopup
                        cancelForm={this.hideModal.bind(this)}
                        ref={(scope) => (this.inOutForm = scope)}
                        selectedPortfolioId={this.state.selectedPortfolioId}
                        selectedBrokerId={this.state.selectedBrokerId}
                        onRefresh={this.onPageDataRefresh.bind(this)}
                        userBrokersData={this.state.userBrokersData}
                        userBasketsData={this.state.userBasketsDataMain}
                      />
                    </div>
                  )}
                  {this.state.buysellPopup && (
                    <div className="formsPopup">
                      <BuySell
                        isPopup
                        cancelForm={this.hideModal.bind(this)}
                        selectedPortfolioId={this.state.selectedPortfolioId}
                        selectedBrokerId={this.state.selectedBrokerId}
                        Rendered={this.state.serverResponse}
                        ref={(scope) => (this.buySellForm = scope)}
                        onRefresh={this.onPageDataRefresh.bind(this)}
                        userBrokersData={this.state.userBrokersData}
                        userBasketsData={this.state.userBasketsDataMain}
                        symbolsData={this.state.symbolsData}
                      />
                    </div>
                  )}
                  {this.state.dpsPopup && (
                    <div className="formsPopup" ref={this.DPSFormDiv}>
                      <DPS
                        isPopup
                        cancelForm={this.hideModal.bind(this)}
                        submitDPSDevisionSuccess={this.submitDPSDevisionSuccess.bind(
                          this
                        )}
                        showSuggestion={this.showDPSSuggestion.bind(this)}
                        selectedPortfolioId={this.state.selectedPortfolioId}
                        selectedBrokerId={this.state.selectedBrokerId}
                        ref={(scope) => (this.DPSForm = scope)}
                        onRefresh={this.onPageDataRefresh.bind(this)}
                        userBasketsData={this.state.userBasketsDataMain}
                        symbolsData={this.state.symbolsData}
                      />
                    </div>
                  )}
                  {this.state.capitalincreasePopup && (
                    <div className="formsPopup" ref={this.CapitalIncreaseDiv}>
                      <CapitalIncrease
                        isPopup
                        cancelForm={this.hideModal.bind(this)}
                        submitIncreaseDevisionSuccess={this.submitIncreaseDevisionSuccess.bind(
                          this
                        )}
                        showSuggestion={this.showIncreaseSuggestion.bind(this)}
                        selectedBrokerId={this.state.selectedBrokerId}
                        selectedPortfolioId={this.state.selectedPortfolioId}
                        ref={(scope) => (this.capitalIncreaseForm = scope)}
                        onRefresh={this.onPageDataRefresh.bind(this)}
                        userBrokersData={this.state.userBrokersData}
                        userBasketsData={this.state.userBasketsDataMain}
                        symbolsData={this.state.symbolsData}
                      />
                    </div>
                  )}
                  {this.state.advancerightPopup && (
                    <div className="formsPopup">
                      <AdvanceRight
                        isPopup
                        cancelForm={this.hideModal.bind(this)}
                        selectedPortfolioId={this.state.selectedPortfolioId}
                        selectedBrokerId={this.state.selectedBrokerId}
                        ref={(scope) => (this.advanceRightForm = scope)}
                        onRefresh={this.onPageDataRefresh.bind(this)}
                        userBrokersData={this.state.userBrokersData}
                        userBasketsData={this.state.userBasketsDataMain}
                        symbolsData={this.state.symbolsData}
                      />
                    </div>
                  )}
                  {this.state.brokerbenefitPopup && (
                    <div className="formsPopup">
                      <BrokerBenefit
                        isPopup
                        cancelForm={this.hideModal.bind(this)}
                        ref={(scope) => (this.BrokerBenefitForm = scope)}
                        selectedPortfolioId={this.state.selectedPortfolioId}
                        selectedBrokerId={this.state.selectedBrokerId}
                        onRefresh={this.onPageDataRefresh.bind(this)}
                        userBrokersData={this.state.userBrokersData}
                        userBasketsData={this.state.userBasketsDataMain}
                      />
                    </div>
                  )}
                  {this.state.brokercreditPopup && (
                    <div className="formsPopup">
                      <BrokerCredit
                        isPopup
                        cancelForm={this.hideModal.bind(this)}
                        ref={(scope) => (this.BrokerCreditForm = scope)}
                        selectedPortfolioId={this.state.selectedPortfolioId}
                        selectedBrokerId={this.state.selectedBrokerId}
                        onRefresh={this.onPageDataRefresh.bind(this)}
                        userBrokersData={this.state.userBrokersData}
                        userBasketsData={this.state.userBasketsDataMain}
                      />
                    </div>
                  )}
                  {this.state.transferPopup && (
                    <div className="formsPopup">
                      <Transfer
                        isPopup
                        cancelForm={this.hideModal.bind(this)}
                        ref={(scope) => (this.transferForm = scope)}
                        onRefresh={this.onPageDataRefresh.bind(this)}
                        userBasketsData={this.state.userBasketsDataMain}
                        selectedBrokerId={this.state.selectedBrokerId}
                        userBrokersData={this.state.userBrokersData}
                        symbolsData={this.state.symbolsData}
                      />
                    </div>
                  )}
                  {this.state.importexcelPopup && (
                    <div className="formsPopup">
                      <ImportExcel
                        isPopup
                        cancelForm={this.hideModal.bind(this)}
                        ref={(scope) => (this.ImportExcelForm = scope)}
                        selectedPortfolioId={this.state.selectedPortfolioId}
                        selectedBrokerId={this.state.selectedBrokerId}
                        onRefresh={this.onPageDataRefresh.bind(this)}
                        userBrokersData={this.state.userBrokersData}
                        userBasketsData={this.state.userBasketsDataMain}
                      />
                    </div>
                  )}
                  {/* message={sessionStorage.getItem("description")} */}
                  {this.state.newVersion && (
                    <MessagePrompt
                      title={sessionStorage.getItem("title")}
                      message={this.state.newVersionText}
                      buttonTitle="متوجه شدم"
                      buttonVariant="primary"
                      hideModal={this.hideModal.bind(this)}
                    />
                  )}
                  {this.state.twrrMessage && (
                    <MessagePrompt
                      title="TWRR چیست؟"
                      message="twrr"
                      buttonTitle="بستن"
                      buttonVariant="danger"
                      hideModal={this.hideModal.bind(this)}
                    />
                  )}
                  {this.state.mwrrMessage && (
                    <MessagePrompt
                      title="MRWW چیست؟"
                      message="mwrr"
                      buttonTitle="بستن"
                      buttonVariant="danger"
                      hideModal={this.hideModal.bind(this)}
                    />
                  )}
                </Modal>
              </div>
            </div>
            <ToastContainer rtl transition={Flip} />
          </div>
        );
      } else {
        return <Redirect to="/Login" />;
      }
    } else {
      return <Loading />;
    }
  }
}
